<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          :class="{'card-shrink-active': shrink_1, 'card-shrink-115': shrink_1}"
          title="Lcd HDR Calibration Analyzer"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <v-icon
            :class="{'card-shrink-active-icon' : shrink_1}"
            @click="shrink_1=!shrink_1"
          >mdi-apple-keyboard-control</v-icon>
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout wrap>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryFactory"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryFactoryMenu"
                    label="Factory"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryProject"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryProjectMenu"
                    label="Project"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summaryCalibrationType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryCalibrationTypeMenu"
                    label="Type"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryProdId"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryProdIdMenu"
                    label="PROD ID"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  d-flex
                  align-items-center
                  xs12
                  lg4>
                  <p class="m-0">Time Interval</p>
                  <v-menu
                    v-model="summaryRangeStartDateMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryRangeStartDate"
                      label=""
                      prepend-icon="event"
                    />
                    <v-date-picker
                      ref="datePicker"
                      v-model="summaryRangeStartDate"
                      :min="startdate"
                      :max="new Date() | date-format"
                      :events="highlightedEventDates"
                      :event-color="getEventColor"
                      :color="theme==='dark'?'danger':'general'"
                      type="date"
                      no-title
                    />
                    <!-- <template
                        slot="day-content"
                      >
                        <div>Test Static Content</div>
                      </template>
                      <template
                        slot="day-content"
                        slot-scope="props"
                      >
                        <div :class="['custom-date', { 'is-active': props.isActive, 'is-current': props.isCurrent }]">
                          {{ props.current }}12312
                          <div
                            v-if="isMarkedDate(props.day)"
                            style="width: 5px; height: 5px; background-color: blue; border-radius: 50%; position: absolute; bottom: 5px; left: 50%; transform: translateX(-50%);"
                          />
                          <pre>{{ props }}</pre>
                        </div>
                      </template>
                    </v-date-picker> -->
                  </v-menu>
                  <!-- <v-menu
                    v-model="startTimeMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    style="max-width: 100px;margin-left: 10px;"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="startTime"
                      label=""
                      prepend-icon=""
                    />
                    <v-time-picker
                      v-model="startTime"
                      :color="theme==='dark'?'error':'general'"
                      :allowed-minutes="m => m % 30 === 0"
                      format="24hr"
                      type="time"/>
                  </v-menu> -->
                  <p class="m-0 text-center px-3">到</p>
                  <v-menu
                    v-model="summaryRangeEndDateMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryRangeEndDate"
                      label=""
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryRangeEndDate"
                      :min="summaryRangeStartDate"
                      :max="new Date() | date-format"
                      :events="highlightedEndEventDates"
                      :event-color="getEndEventColor"
                      :color="theme==='dark'?'danger':'general'"
                      type="date"
                      no-title
                      scrollable
                      actions/>
                  </v-menu>
                  <!-- <v-menu
                    v-model="endTimeMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    style="max-width: 100px;margin-left: 10px;"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="endTime"
                      label=""
                      prepend-icon=""
                    />
                    <v-time-picker
                      v-model="endTime"
                      :color="theme==='dark'?'error':'general'"
                      :allowed-minutes="m => m % 30 === 0"
                      format="24hr"
                      type="time"/>
                  </v-menu> -->
                </v-flex>
                <v-flex
                  xs12
                  lg11/>
                <v-flex
                  flex-small
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center
                >
                  <v-btn
                    v-if="shrink_1"
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSubmit()"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                    <!-- <button @click="exportToExcel" class="excel-export-btn">
      <i class="fas fa-file-excel"></i> 匯出 Excel
    </button> -->
                  <!-- <v-btn
                    v-if="shrink_1"
                    class="mx-2 font-weight-light"
                    color="general"
                    @click="downloadXLS()"
                  >
                    <v-icon class="mr-2">mdi-export</v-icon>匯出XLS
                  </v-btn> -->
                </v-flex>
                <v-flex
                  flex-small
                  border-primary
                  mt-3
                  xs12
                  lg12
                  style="border-top: 2px dashed;"/>
                <v-flex
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <v-text-field
                    v-model="biosSn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="BIOS SN"/>
                </v-flex>
                <v-flex
                  flex-small
                  xs12
                  sm6
                  lg3>
                  <v-text-field
                    v-model="i1Sn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="i1 SN"/>
                </v-flex>
                <!-- <v-flex
                  flex-small
                  xs12
                  sm6
                  lg1>
                  <v-text-field
                    v-model="prodid"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="PROD ID"/>
                </v-flex> -->
                <v-flex
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <v-text-field
                    v-model="mfrid"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="MFR ID"/>
                </v-flex>
                <v-flex
                  flex-small
                  xs12
                  sm6
                  lg1>
                  <v-text-field
                    v-model="mfrdate"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="MFR DATE"/>
                </v-flex>
                <v-flex
                  flex-small
                  xs12
                  sm6
                  lg4>
                  <v-text-field
                    v-model="errorCode"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="Error Code"/>
                </v-flex>
                <v-flex
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <p class="m-0">Data Type:</p>
                   <v-autocomplete
                    v-model="selectedDataType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="[
                      { text: 'All', value: '' },
                      { text: 'Gray Level', value: 'grayLevel' },
                      { text: 'Color Volume', value: 'colorVolume' },
                      { text: 'Coverage', value: 'coverage' },
                    ]"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex v-if="selectedDataType === 'grayLevel'"
                  flex-small
                  xs12
                  sm6
                  lg3>
                  <p class="m-0">Luminance:</p>
                   <v-autocomplete
                    v-model="selectedLuminance_G"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="luminanceOptions_G"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                  <v-flex v-if="selectedDataType === 'grayLevel'"
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <p class="m-0">Mode:</p>
                   <v-autocomplete
                    v-model="selectedMode_G"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="modeOptions_G"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex v-if="selectedDataType === 'grayLevel'"
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg5>
                  <p
                    class="m-0"
                    style="width: 200px;">dlTP Range:</p>
                  <v-text-field
                    v-model="dltpstart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                  <p class="m-0 text-center px-3">To:</p>
                  <v-text-field
                    v-model="dltpend"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                </v-flex>
                  <v-flex  v-if="selectedDataType === 'grayLevel'"
                  flex-small
                  xs12
                  sm6
                  lg7>
                </v-flex>
                <v-flex v-if="selectedDataType === 'grayLevel'"
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg5>
                  <p
                    class="m-0"
                    style="width: 200px;">dTP Range:</p>
                  <v-text-field
                    v-model="dtpstart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                  <p class="m-0 text-center px-3">To:</p>
                  <v-text-field
                    v-model="dtpend"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                </v-flex>
                <v-flex v-if="selectedDataType === 'grayLevel'"
                  flex-small
                  xs12
                  sm6
                  lg7>
                </v-flex>
                <v-flex v-if="selectedDataType === 'grayLevel'"
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg5>
                  <p
                    class="m-0"
                    style="width: 200px;">Luminance Range(%):</p>
                  <v-text-field
                    v-model="lumistart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                  <p class="m-0 text-center px-3">To:</p>
                  <v-text-field
                    v-model="lumiend"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                </v-flex>
                  <v-flex v-if="selectedDataType === 'colorVolume'"
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <p class="m-0">Luminance:</p>
                   <v-autocomplete
                    v-model="selectedLuminance_C"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="luminanceOptions_C"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                  <v-flex v-if="selectedDataType === 'colorVolume'"
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <p class="m-0">Color:</p>
                   <v-autocomplete
                    v-model="selectedColor_C"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="ColorOptions_C"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                  <v-flex v-if="selectedDataType === 'colorVolume'"
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <p class="m-0">Mode:</p>
                   <v-autocomplete
                    v-model="selectedMode_C"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="ModeOptions_C"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex v-if="selectedDataType === 'colorVolume'"
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg4>
                  <p
                    class="m-0"
                    style="width: 200px;">dlTP Range:</p>
                  <v-text-field
                    v-model="dltpstart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                  <p class="m-0 text-center px-3">To:</p>
                  <v-text-field
                    v-model="dltpend"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                </v-flex>
                  <v-flex  v-if="selectedDataType === 'colorVolume'"
                  flex-small
                  xs12
                  sm6
                  lg8>
                </v-flex>
                <v-flex v-if="selectedDataType === 'colorVolume'"
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg4>
                  <p
                    class="m-0"
                    style="width: 200px;">dTP Range:</p>
                  <v-text-field
                    v-model="dtpstart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                  <p class="m-0 text-center px-3">To:</p>
                  <v-text-field
                    v-model="dtpend"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                </v-flex>
                <v-flex v-if="selectedDataType === 'coverage'"
                  flex-small
                  xs12
                  sm6
                  lg3>
                  <p class="m-0">Color Gamut:</p>
                   <v-autocomplete
                    v-model="selectedgamut_Cov"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="gamutOptions_Cov"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                  <v-flex v-if="selectedDataType === 'coverage'"
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <p class="m-0">Mode:</p>
                   <v-autocomplete
                    v-model="selectedMode_Cov"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="modeOptions_Cov"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex v-if="selectedDataType === 'coverage'"
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg5>
                  <p
                    class="m-0"
                    style="width: 200px;">Range:</p>
                  <v-text-field
                    v-model="dltpstart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                  <p class="m-0 text-center px-3">To:</p>
                  <v-text-field
                    v-model="dltpend"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                </v-flex>
                <!-- <v-flex
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg2>
                  <v-autocomplete
                    v-model="deltsitps"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="[
                      { text: 'Result', value: 'Result' },
                      { text: '100Nits', value: '100Nits' },
                      { text: '50Nits', value: '50Nits' },
                      { text: '50Tier', value: '50Tier' }
                    ]"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg4>
                  <p
                    class="m-0"
                    style="width: 140px;">dlTP:</p>
                  <v-text-field
                    v-model="dltpstart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                  <p class="m-0 text-center px-3">to:</p>
                  <v-text-field
                    v-model="dltpend"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                </v-flex>
                <v-flex
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg2>
                  <v-autocomplete
                    v-model="deltstps"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="[
                      { text: '100Nits', value: '100Nits' },
                      { text: '50Nits', value: '50Nits' },
                      { text: '50Tier', value: '50Tier' }
                    ]"
                    label=""
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  d-flex
                  align-items-center
                  xs12
                  lg4>
                  <p
                    class="m-0"
                    style="width: 140px;">dTP:</p>
                  <v-text-field
                    v-model="dtpstart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                  <p class="m-0 text-center px-3">to:</p>
                  <v-text-field
                    v-model="dtpend"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label=""/>
                </v-flex> -->
                <v-flex
                  xs12
                  lg11/>
                <v-flex
                  flex-small
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSubmit()"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
                <v-flex
                  xs12
                  lg12
                />
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        v-if="submit"
        xs12
        sm6
        lg3>
        <material-stats-card
          v-model="passAmount"
          class="v-offset-none text-success"
          style="margin:0 !important;"
          color="purple"
          icon="mdi-folder-open"
          title="Test Pass"/>
      </v-flex>
      <v-flex
        v-if="submit"
        xs12
        sm6
        lg3>
        <material-stats-card
          v-model="failAmount"
          class="v-offset-none text-danger"
          style="margin:0 !important;"
          color="indigo"
          icon="mdi-calendar"
          title="Test Fail"/>
      </v-flex>
      <v-flex
        v-if="submit"
        xs12
        sm6
        lg3>
        <material-stats-card
          v-model="totalTestInputs"
          class="v-offset-none text-info"
          style="margin:0 !important;"
          color="light-blue"
          icon="mdi-factory"
          title="Test Total"/>
      </v-flex>
      <v-flex
        v-if="submit"
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="(totalTestInputs>0?((Number(passAmount)/Number(totalTestInputs) * 100).toFixed(1)):0) + '%'"
          :class="(Number(passAmount)/Number(totalTestInputs)<0.8)?'red':'green'"
          :color="(Number(passAmount)/Number(totalTestInputs)<0.8)?'pink':'light-green'"
          :icon="(Number(passAmount)/Number(totalTestInputs)<0.8)?'mdi-alert':'mdi-check'"
          class="title-color"
          style="margin:0 !important;"
          title="Test Pass Rate"/>
      </v-flex>
      <v-flex
        v-if="submit"
        flex_width_auto
        xs12>
        <material-card
          id="checkTable"
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          title="查詢結果列表"
          color="deep-orange"
          class="card-mix card-padding">
          <v-select
            v-model="pagination.current.rowsPerPage"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="rowsAmount"
            class="mix-list v-text-field__slot d-inline-block float-right ml-5"
            style="width: 90px;"
            persistent-hint
            outlined
          />
 <!-- <v-menu offset-y v-if="responseData.length > 0" style="position: absolute !important;z-index: 1000 !important;" attach="#checkTable">
  <template v-slot:activator="{ on, attrs }">
    <v-btn class="black text-light primary mx-0 px-2" v-bind="attrs" v-on="on">
      <v-icon class="mr-1">mdi-chart-scatterplot-hexbin</v-icon>2D(x,y)Gray
    </v-btn>
  </template>

  <v-list style="max-height: 200px; overflow-y: auto;">
    <router-link :to="'/lcd/lcdCalibrationAnalyzer/showLcdCalibration2DXYScatterPlotView'"
    style="text-decoration: none; color: white;"
    target="_blank">
    <v-list-item
      class="d-block pa-2"
      style="cursor: pointer;">
      <v-list-item-icon>
        <v-icon>mdi-chart-scatterplot</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>156</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
     </router-link>

<router-link :to="'/lcd/lcdCalibrationAnalyzer/showLcdCalibration3DScatterPlotView'"
 style="text-decoration: none; color: white;"
  target="_blank">
    <v-list-item
      class="d-block pa-2"
      style="cursor: pointer;">
      <v-list-item-icon>
        <v-icon>mdi-chart-scatter-plot</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>256</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
</router-link>

  </v-list>
</v-menu> -->
 <!-- 按钮部分 -->
    <div v-if="responseData.length>0"
        class="mix-btn p-0"
            style="right: 56.5rem;">
    <v-btn
      @click="toggleDropdown"
      class="black text-light primary mx-0 px-2"
       style="text-transform: none;"
    >
      <v-icon class="mr-1">mdi-chart-line</v-icon>2D(X,Y)_Gray
    </v-btn>

    <!-- 下拉列表部分 -->
       <v-list v-if="dropdownVisible_Gray"  style="position: absolute;max-height: 10rem; width:7.8rem;overflow-y: auto;z-index: 9999;">
       <v-list-item
        v-for="(result, index) in Gray2DList"
        :key="index"
        class="d-block pa-1"
        style="cursor: pointer;"
        @click="goTo2DGrayLink(result.value)"
      >
      {{ result.text }}
        <!-- <v-list-item-content>
          <v-list-item-title></v-list-item-title>
        </v-list-item-content> -->
      </v-list-item>
      </v-list>
    </div>

     <div v-if="responseData.length>0"
        class="mix-btn p-0"
            style="right: 46.5rem;">
    <v-btn
      @click="toggleDropdown_Color"
      class="black text-light primary mx-0 px-2"
       style="text-transform: none;"
    >
      <v-icon class="mr-1">mdi-chart-line</v-icon>2D(X,Y)_Color
    </v-btn>

    <!-- 下拉列表部分 -->
       <v-list v-if="dropdownVisible_Color"  style="position: absolute;max-height: 10rem; width:8.2rem;overflow-y: auto;z-index: 9999;">
         <v-list-item
        v-for="(color, index) in color2DList"
        :key="index"
        class="d-block pa-1"
        style="cursor: pointer;"
        @click="goTo2DColorLink(color.value)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ color.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </v-list>
    </div>

     <div v-if="responseData.length>0"
        class="mix-btn p-0"
            style="right: 35.5rem;">
    <v-btn
      @click="toggleDropdown_GrayBox"
      class="black text-light primary mx-0 px-2"
       style="text-transform: none;"
    >
      <v-icon class="mr-1">mdi-chart-bar-stacked</v-icon>BoxPlot_Gray
    </v-btn>

    <!-- 下拉列表部分 -->
       <v-list v-if="dropdownVisible_GrayBox"  style="position: absolute;max-height: 10rem; width:8.5rem;overflow-y: auto;z-index: 9999;">
         <v-list-item
        v-for="(result, index) in colorGrayBoxList"
        :key="index"
        class="d-block pa-1"
        style="cursor: pointer;"
        @click="goToGrayBoxLink(colorGrayBoxValueList[index])"
      >
        <v-list-item-content>
          <v-list-item-title>{{ result }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </v-list>
    </div>

     <div v-if="responseData.length>0"
        class="mix-btn p-0"
            style="right: 24.5rem;">
    <v-btn
      @click="toggleDropdown_ColorBox"
      class="black text-light primary mx-0 px-2"
       style="text-transform: none;"
    >
      <v-icon class="mr-1">mdi-chart-bar-stacked</v-icon>BoxPlot_Color
    </v-btn>

    <!-- 下拉列表部分 -->
       <v-list v-if="dropdownVisible_ColorBox"  style="position: absolute;max-height: 10rem; width:9rem;overflow-y: auto;z-index: 9999;">
         <v-list-item
        v-for="(result, index) in colorColorBoxList"
        :key="index"
        class="d-block pa-1"
        style="cursor: pointer;"
        @click="goToColorBoxLink(result.value,result.type)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ result.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </v-list>
    </div>

     <!-- <div
        class="mix-btn p-0"
            style="right: 16.5rem;"> -->
            <router-link
            v-if="responseData.length>0"
            :to="'/lcd/hdr/lcdCalibrationAnalyzer/ShowHDRLcdCalibrationCoverageChat'"
            class="mix-btn p-0"
            style="right: 16.5rem;"
            target="_blank">
            <v-btn class="black text-light primary mx-0 px-2"  @click="toggleDropdown_Cov"  style="text-transform: none;">
              <v-icon class="float-left mr-1">mdi-chart-bar</v-icon>Coverage
            </v-btn>
          </router-link>
    <!-- <v-btn
      @click="toggleDropdown_Cov"
      class="black text-light primary mx-0 px-2"
    >
      <v-icon class="mr-1">mdi-chart-bar</v-icon>coverage
    </v-btn>

       <v-list v-if="dropdownVisible_Cov"  style="position: absolute;max-height: 10rem; width:7rem;overflow-y: auto;z-index: 9999;">
         <v-list-item
        v-for="(result, index) in colorCovList"
        :key="index"
        class="d-block pa-1"
        style="cursor: pointer;"
        @click="goToCoverageLink(result)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ result }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </v-list> -->
    <!-- </div> -->
          <!-- <router-link
            v-if="responseData.length>0"
            :to="'/lcd/lcdCalibrationAnalyzer/showLcdCalibration2DXYScatterPlotView'"
            class="mix-btn p-0"
            style="right: 54.5rem;"
            target="_blank">
            <v-btn class="black text-light primary mx-0 px-2">
              <v-icon class="float-left mr-1">mdi-chart-scatterplot-hexbin</v-icon>2D(x,y)
            </v-btn>
          </router-link> -->
          <!-- <router-link
            v-if="responseData.length>0"
            :to="'/lcd/lcdCalibrationAnalyzer/showLcdCalibrationLuminanceYBarChartView'"
            class="mix-btn p-0"
            style="right: 44.5rem;"
            target="_blank">
            <v-btn class="black text-light primary mx-0 px-2">
              <v-icon class="float-left mr-1">mdi-chart-bar</v-icon>Luminance(Y)
            </v-btn>
          </router-link>
          <router-link
            v-if="responseData.length>0"
            :to="'/lcd/lcdCalibrationAnalyzer/showLcdCalibrationDeltaEDistributionBarChartView'"
            class="mix-btn p-0"
            style="right: 31.5rem;"
            target="_blank">
            <v-btn class="black text-light primary mx-0 px-2">
              <v-icon class="float-left mr-1">mdi-chart-bar</v-icon>Delta E Distribution
            </v-btn>
          </router-link>
          <router-link
            v-if="responseData.length>0"
            :to="'/lcd/lcdCalibrationAnalyzer/showLcdCalibrationGammaDiffBarChartView'"
            class="mix-btn p-0"
            style="right: 22.5rem;"
            target="_blank">
            <v-btn class="black text-light primary mx-0 px-2">
              <v-icon class="float-left mr-1">mdi-chart-bar</v-icon>Gamma Diff
            </v-btn>
          </router-link>
          <router-link
            v-if="responseData.length>0"
            :to="'/lcd/lcdCalibrationAnalyzer/showLcdCalibrationGammaBarChartView'"
            class="mix-btn p-0"
            style="right: 15.5rem;"
            target="_blank">
            <v-btn class="black text-light primary mx-0 px-2">
              <v-icon class="float-left mr-1">mdi-chart-bar</v-icon>Gamma
            </v-btn>
          </router-link> -->
          <v-btn
            v-if="responseData.length>0"
            class="mix-btn black text-light"
            style="right: 8rem;"
            @click="downloadXLS()">
            <v-icon class="float-left mr-1">mdi-download</v-icon>下載Excel
          </v-btn>
          <v-autocomplete
            id="checkTableInput"
            v-model="checkTableShowList"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items= checkTableInputDefine
            label="選擇欄位"
            class="v-text-field__slot row-btn-175 pt-0 mt-3"
            color="white"
            multitude
            chips
            persistent-hint
            multiple
            outlined
          />
          <v-btn
            class="red text-light float-right mr-0 mt-4"
            @click="checkTableShowListClear()"
          >
            清除
          </v-btn>
          <v-btn
            class="blue text-light float-right mt-4"
            @click="checkTableShowListAll()"
          >
            全選
          </v-btn>
        </material-card>
        <material-card
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          class="d-table-t0 no-data-left">
          <!-- <v-select
            v-model="pagination.rowsPerPage"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="rowsAmount"
            class="v-text-field__slot d-inline-block float-right ml-5"
            style="width: 90px;"
            persistent-hint
            outlined
          /> -->
          <v-data-table
            :headers="responseHeaders"
            :items="responseData"
            :pagination.sync="pagination.current"
            :rows-per-page-items="rowsAmount"
            :class="{ 'showList': checkTableShowList.length>0}"
            class="freeze-title height-row-3"
            multi-sort
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr>
                <td class="table-width-150">{{ item.biosSn }}</td>
                <td class="table-width-175">{{ item.i1Sn }}</td>
                <td class="table-width-90">{{ item.mfrId }}</td>
                <td class="table-width-100">{{ item.prodId }}</td>
                <td class="table-width-100">{{ item.apver }}</td>
                <td class="table-width-125">{{ item.biosId }}</td>
                <td class="table-width-185">{{ item.lunchTime }}</td>
                <td class="table-width-185">{{ item.startTime }}</td>
                <td class="table-width-185">{{ item.endTime }}</td>
                <td class="table-width-110">{{ item.errorCode }}</td>
                <td class="table-width-150">{{ item.measureLoop }}</td>
<td class="table-width-150">{{ item.validation0 }}</td>
<td class="table-width-150">{{ item.validation1 }}</td>
<td class="table-width-150">{{ item.validation2 }}</td>
<td class="table-width-150">{{ item.writeBIOS }}</td>
<td class="table-width-150">{{ item.panelIndex }}</td>
<td class="table-width-150">{{ item.vesaVer }}</td>
<td class="table-width-150">{{ item.vesaCriteria }}</td>
                <td class="table-width-110">{{ item.mfrDate }}</td>
                <td class="table-width-300">
                  <v-btn
                    class="mx-0 mr-3 font-weight-bold small"
                    color="orange"
                    @click="downloadHitTraceLog(item.pk)">
                    <v-icon class="mr-2">mdi-download</v-icon>HITTrace LOG
                  </v-btn>
                  <v-btn
                    class="mx-0 font-weight-bold small"
                    color="orange"
                    @click="downloadNBreport(item.pk)">
                    <v-icon class="mr-2">mdi-download</v-icon>NB Report
                  </v-btn>
                </td>
                <td
                  v-for="(col, index) in responseTableShowList"
                  v-show="responseTableShowList[index]"
                  :class="responseColumnClassList[index]+' text-xs-'+responseAlignList[index]"
                  :key="'col'+index"
                >
                  {{ item[index] }}
                  <router-link
                    v-if="index==='xyzInfo'&&item.pk"
                    :to="'/lcd/hdr/lcdCalibrationAnalyzer/showLcdCalibrationXYZInfoView/' + item.pk"
                    target="_blank">
                    <v-btn
                      class="mx-0 mr-3 font-weight-light small"
                      color="green">
                      <v-icon class="mr-2">mdi-file-find</v-icon>X/Y/Z Info
                    </v-btn>
                  </router-link>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div
            v-if="pagination.current.rowsPerPage != -1"
            class="text-xs-center pt-2 d-inline-block"
            style="margin-left: 0px;width: calc(100% - 140px);">
            <v-pagination
              v-model="pagination.page"
              :length="pages"/>
          </div>
          <v-autocomplete
            v-if="pagination.current.rowsPerPage != -1"
            v-model="pagination.page"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="pageslist"
            class="v-text-field__slot d-inline-block float-right mr-0"
            style="width: 90px;"
            persistent-hint
            outlined
          />
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
// import * as XLSX from 'xlsx'
import qs from 'qs'
import Vue from 'vue'
// import Vuetify from 'vuetify'
// import VueC3 from 'vue-c3'
// import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'
export default {
  name: 'LcdHDRCalibrationAnalyzer',
  // components: {
  //   VueC3
  // },
  data () {
    return {
      startdate: '2018-04-01',
      highlightedDates: ['2025-02-10', '2025-02-14', '2024-02-20'],
      highlightedEndDates: ['2025-02-08', '2025-02-13', '2024-02-14'],
      availableColors: [
        'green', // 0
        'blue', // 1
        'yellow', // 2
        'orange', // 3
        'purple', // 4
        'teal', // 5
        'brown', // 6
        'pink' // 7
      ],
      pointColorOverride: {},
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      processingView: false,
      // summaryCaseName: '',
      // summaryDate: '',
      // summaryEMS: '',
      // summaryEMSpk: 0,
      // summaryRange: '5',
      // summaryItem: 'CPU_TEMP',
      summaryTableShowList: [],
      // nullDatetime: null,
      // datetime: new Date(),
      // datetimeString: '2019-01-01 12:00',
      // formattedDatetime: '09/01/2019 12:00',
      // textFieldProps: {
      //   appendIcon: 'event'
      // },
      // dateProps: {
      //   headerColor: 'red'
      // },
      // timeProps: {
      //   useSeconds: false,
      //   ampmInTitle: true,
      //   format: '24hr',
      //   allowedMinutes: m => m % 30 === 0
      // },
      shrink_1: true,
      summaryRangeStartDateMenu: false,
      summaryRangeStartDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryRangeEndDateMenu: false,
      summaryRangeEndDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryFactoryMenu: [],
      summaryFactory: '',
      tempFactory: '',
      summaryProjectMenu: [],
      summaryProject: '',
      tempProject: '',
      summaryCalibrationTypeMenu: [],
      summaryCalibrationType: '',
      tempCalibrationType: '',
      summaryProdIdMenu: [],
      summaryProdId: '',
      tempProdId: '',
      deltsitps: '',
      dltpstart: '',
      dltpend: '',
      deltstps: '',
      dtpstart: '',
      dtpend: '',
      biosSn: '',
      i1Sn: '',
      prodid: '',
      mfrid: '',
      mfrdate: '',
      errorCode: '',
      yRangeType: '',
      yRangeStart: '',
      yRangeEnd: '',
      xyCoordinateRangeType: '',
      xCoordinateRangeStart: '',
      xCoordinateRangeEnd: '',
      yCoordinateRangeStart: '',
      yCoordinateRangeEnd: '',
      gammaRangeStart: '',
      gammaRangeEnd: '',
      gammaDiffRangeStart: '',
      gammaDiffRangeEnd: '',
      summary: {
        biosSn: '',
        i1Sn: '',
        mfrid: '',
        mfrdate: '',
        errorCode: '',
        yRangeType: '',
        yRangeStart: '',
        yRangeEnd: '',
        xyCoordinateRangeType: '',
        xCoordinateRangeStart: '',
        xCoordinateRangeEnd: '',
        yCoordinateRangeStart: '',
        yCoordinateRangeEnd: '',
        gammaRangeStart: '',
        gammaRangeEnd: '',
        gammaDiffRangeStart: '',
        gammaDiffRangeEnd: ''
      },
      // RangeAll: true,
      // RangeIndex: 999,
      // RangeMin: 0,
      // RangeMax: 9999,
      // RangeMaxList: {
      //   CPU_TEMP: 200,
      //   GPU_TEMP: 200,
      //   CPU_POWER: 200,
      //   GPU_POWER: 200
      // },
      // OverRangeCount: 0,
      // RangeCount: 1,
      passAmount: '0',
      failAmount: '0',
      totalTestInputs: '0',
      submit: false,
      IsSubmitPage: true,
      isSorting: false,
      responseData: [],
      responseDataOnly: [],
      checkTableInputDefine: [],
      responseColumnDefine: [
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'BiosSN',
          value: 'biosSn'
        },
        {
          align: '',
          class: 'table-width-175',
          fixed: true,
          sortable: true,
          text: 'i1_SN',
          value: 'i1Sn'
        },
        {
          align: '',
          class: 'table-width-90',
          fixed: true,
          sortable: true,
          text: 'MFR_ID',
          value: 'mfrId'
        },
        {
          align: '',
          class: 'table-width-100',
          fixed: true,
          sortable: true,
          text: 'Prod_ID',
          value: 'prodId'
        },
        {
          align: '',
          class: 'table-width-100',
          fixed: true,
          sortable: true,
          text: 'Apver',
          value: 'apver'
        },
        {
          align: '',
          class: 'table-width-125',
          fixed: true,
          sortable: true,
          text: 'BIOS_ID',
          value: 'biosId'
        },
        {
          align: '',
          class: 'table-width-185',
          fixed: true,
          sortable: true,
          text: 'Launchtime',
          value: 'lunchTime'
        },
        {
          align: '',
          class: 'table-width-185',
          fixed: true,
          sortable: true,
          text: 'Starttime',
          value: 'startTime'
        },
        {
          align: '',
          class: 'table-width-185',
          fixed: true,
          sortable: true,
          text: 'Endtime',
          value: 'endTime'
        },
        {
          align: '',
          class: 'table-width-110',
          fixed: true,
          sortable: true,
          text: 'ErrorCode',
          value: 'errorCode'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'MeasureLoop',
          value: 'measureLoop'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Validation0',
          value: 'validation0'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Validation1',
          value: 'validation1'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Validation2',
          value: 'validation2'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'WriteBIOS',
          value: 'writeBIOS'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'PanelIndex',
          value: 'panelIndex'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'VESAVer',
          value: 'vesaVer'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'VESACriteria',
          value: 'vesaCriteria'
        },
        {
          align: '',
          class: 'table-width-110',
          fixed: true,
          sortable: true,
          text: 'MFR_Date',
          value: 'mfrDate'
        },
        {
          align: '',
          class: 'table-width-300',
          fixed: true,
          sortable: true,
          text: '操作',
          value: ''
        }
      ],
      responseHeaders: [],
      responseHeadersOnly: [],
      responseHeadersList: [],
      responseColumnClassList: {},
      responseAlignList: {},
      responseTableShowList: {},
      responseTableShowListOnly: {},
      responseAreaData: {
        commonFailQty: 0,
        commonFailRate: 0,
        failQty: 0,
        failRate: 0,
        fanErrorCodeList: [],
        fanFailQty: 0,
        fanFailRate: 0,
        noDefineFailQty: 0,
        passQty: 0,
        passRate: 0,
        productionQty: 0,
        thermalFailQty: 0,
        thermalFailRate: 0,
        warningColor: 'green'
      },
      checkList: [],
      checkTableShowList: [],
      // lineXaxisName: [],
      // lineXaxisValue: [],
      rowsAmount: [10, 25, 50, 100],
      pagination: {
        page: 1,
        current: {
          descending: null,
          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          totalItems: 0
        }
      },
      selectedDataType: '',
      selectedLuminance_G: '',
      selectedMode_G: '',
      selectedLuminance_C: '',
      selectedColor_C: '',
      selectedMode_C: '',
      selectedgamut_Cov: '',
      selectedMode_Cov: '',
      lumistart: '',
      lumiend: '',
      luminanceOptions_G: [], // 根据选中的 Data Type 动态更新
      modeOptions_G: [], // 根据选中的 Luminance 动态更新
      luminanceOptions_C: [],
      gamutOptions: [],
      ColorOptions_C: [],
      ModeOptions_C: [],
      gamutOptions_Cov: [],
      modeOptions_Cov: [],
      dropdownVisible_Gray: false,
      grayLevelRangeFilter: {
        mode: '',
        luminance: 0,
        ditpRange: {
          min: 0,
          max: 0
        },
        dtpRange: {
          min: 0,
          max: 0
        },
        luminanceRange: {
          min: 0,
          max: 0
        }
      },
      colorVolumeRangeFilter: {
        mode: '',
        luminance: 0,
        color: 0,
        ditpRange: {
          min: 0,
          max: 0
        },
        dtpRange: {
          min: 0,
          max: 0
        }
      },
      coverageRangeFilter: {
        mode: '',
        gamut: '',
        color: 0,
        range: {
          min: 0,
          max: 0
        }
      },
      Gray2DList: [
        '156',
        '256',
        '350',
        '452',
        '520',
        '592',
        '620'
      ],
      dropdownVisible_Color: false,
      color2DList: [],
      dropdownVisible_GrayBox: false,
      colorGrayBoxList: [
        'dITP',
        'dTP',
        'Y%'
      ],
      colorGrayBoxValueList: [
        'dITP',
        'dTP',
        'luminance'
      ],
      dropdownVisible_ColorBox: false,
      colorColorBoxList: [],
      colorNitsList: [
        '50',
        '50',
        '75',
        '75',
        '100',
        '100',
        '300',
        '300'
      ],
      colorTypeList: [
        'dITP',
        'dTP',
        'dITP',
        'dTP',
        'dITP',
        'dTP',
        'dITP',
        'dTP'
      ],
      dropdownVisible_Cov: false,
      colorCovList: [
        'Native_Result',
        'Native_sRGB',
        'Native_P3',
        'Cali_Result'
      ],
      pages: 1,
      handler_bar: new Vue(),
      isInitialPageLoad: true
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    // pages () {
    //   if(this.responseData.length > 0) {
    //     return this.pagination.rowsPerPage ? Math.ceil(this.responseData.length / this.pagination.rowsPerPage) : 10
    //   }
    // },
    pageslist () {
      let i = 0
      const list = []
      if (this.pagination.current.rowsPerPage) {
        for (i = 0; i < Math.ceil(this.pagination.current.totalItems / this.pagination.current.rowsPerPage); i++) {
          list.push(i + 1)
        }
      }
      return list
    },
    highlightedEventDates () {
      return this.highlightedDates.map(d => d.manufacturingDate)
    },
    highlightedEndEventDates () {
      return this.highlightedEndDates.map(d => d.manufacturingDate)
    }
    // options_bar () {
    //   return {
    //     data: {
    //       x: 'x',
    //       columns: [
    //         this.barXaxisName,
    //         this.barXaxisValue
    //       ],
    //       labels: true,
    //       // labels: {
    //       //   // format: function (v, id, i, j) { return v + '%' }
    //       // },
    //       // onclick: function (d) { alert(d.index) },
    //       onclick: (d) => { this.summaryList(d.index, 'range') },
    //       type: 'bar',
    //       types: {
    //         'NormalDistribution': 'spline'
    //       },
    //       axes: {
    //         'ModelName': 'y'
    //       }
    //       // colors: {
    //       //   ModelName: '#999999'
    //       // }
    //       // onclick: (d, i) => { this.summaryList(d, i) } // {id: "data23", value: 120, ratio: 0.8, index: 1, name: "data23"}
    //       // color: function (color, d) {
    //       //   // d will be 'id' when called for legends
    //       //   return d.value >= 5.0 ? '#ff0000' : d.value >= 3.0 ? '#ff9800' : color
    //       // }
    //       // color: (color, d) => {
    //       //   // d will be 'id' when called for legends
    //       //   return (this.OverRangeCount > 0 && d.index === this.barXaxisName.length - 2) ? '#ffa500' : color
    //       // }
    //     },
    //     axis: {
    //       x: {
    //         type: 'category', // this needed to load string x value
    //         tick: {
    //           rotate: -45,
    //           multiline: false
    //         }
    //         // label: {
    //         //   text: '期',
    //         //   position: 'outer-center'
    //         // }
    //       },
    //       y: {
    //         // max: this.RangeCount,
    //         // min: 0,
    //         // tick: {
    //         //   // count: this.RangeCount + 1
    //         // },
    //         // padding: {
    //         //   top: 0,
    //         //   bottom: 0
    //         // }
    //         // tick: {
    //         //   format: function (value) { return value + '%' }
    //         // }
    //         // label: {
    //         //   text: '%',
    //         //   position: 'outer-middle'
    //         // }
    //       },
    //       y2: {
    //         // show: true
    //         // label: {
    //         //   text: '億',
    //         //   position: 'outer-middle'
    //         // }
    //       }
    //     },
    //     tooltip: {
    //       format: {
    //         title (d) {
    //           // return `第 ${d} 期`
    //         },
    //         value (value, ratio, id) {
    //           // return `${value} 億`
    //         }
    //       }
    //     },
    //     grid: {
    //       x: {
    //         show: true
    //       },
    //       y: {
    //         show: true
    //       }
    //     },
    //     legend: {
    //       position: 'bottom',
    //       padding: 16,
    //       show: false
    //     },
    //     size: {
    //       // width: 640,
    //       height: 500
    //     }
    //   }
    // }
  },
  watch: {
    summaryFactory (val) {
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/project/${val}`).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryProjectMenu = res.data
            console.info('this.summaryProjectMenu', this.summaryProjectMenu)
            this.summaryCalibrationTypeMenu = []
            this.summaryProdIdMenu = []
            this.summaryProject = ''
            this.summaryCalibrationType = ''
            this.summaryProdId = ''
            this.resetFields()
            console.info('isInitialPageLoad', this.isInitialPageLoad)
            console.info('tempProject', this.tempProject)
            if (this.tempProject !== '' && this.isInitialPageLoad) {
              this.summaryProject = this.tempProject
            }
          }
        })
    },
    summaryProject (val) {
      // this.summaryCalibrationTypeMenu = ['SDR', 'HDR']
      // this.summaryProdIdMenu = []
      // this.summaryCalibrationType = ''
      // this.summaryProdId = ''
      // if (this.tempCalibrationType !== '') {
      //   this.summaryCalibrationType = this.tempCalibrationType
      // }
      const body = {
        factoryPk: this.summaryFactory,
        projectPk: val
      }
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/calibrationType?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryCalibrationTypeMenu = res.data
            this.summaryProdIdMenu = []
            this.summaryCalibrationType = ''
            this.summaryProdId = ''
            this.resetFields()
            console.info('isInitialPageLoad', this.isInitialPageLoad)
            if (this.tempCalibrationType !== '' && this.isInitialPageLoad) {
              this.summaryCalibrationType = this.tempCalibrationType
            }
          }
        })
    },
    summaryCalibrationType (val) {
      if (val === 'SDR') {
        const routeData = this.$router.resolve({ path: `/lcd/lcdCalibrationAnalyzer/${this.summaryFactory}/${this.summaryProject}/${this.summaryCalibrationType}/${this.summaryProdId || 'NA'}/${this.summaryRangeStartDate}/${this.summaryRangeEndDate}` })
        window.open(routeData.href, '_blank')
        setTimeout(() => {
          this.summaryCalibrationType = 'HDR'
          if (this.$route.params.rangeStartDate && this.$route.params.rangeEndDate && this.$route.params.factory && this.$route.params.project && this.$route.params.calibrationType && this.$route.params.prodId) {
            const Url = '/lcd/hdr/lcdCalibrationAnalyzer/' + this.summaryFactory + '/' + this.summaryProject + '/' + this.summaryCalibrationType + '/' + (this.summaryProdId || 'NA') + '/' + this.summaryRangeStartDate + '/' + this.summaryRangeEndDate
            if (this.$router.history.current.path !== Url) {
              this.$router.replace(Url)
            }
          }
        }, 0)
      }
      // this.summaryProdIdMenu = ['102B', '3C4D']
      // this.summaryProdId = ''
      // if (this.tempProdId !== '') {
      //   this.summaryProdId = this.tempProdId
      // }
      const body = {
        factoryPk: this.summaryFactory,
        projectPk: this.summaryProject,
        calibrationType: val
      }
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/prodId?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryProdIdMenu = res.data
            this.summaryProdId = ''
            this.resetFields()
            console.info('isInitialPageLoad', this.isInitialPageLoad)
            if (this.tempProdId !== '' && this.isInitialPageLoad) {
              this.summaryProdId = this.tempProdId
            }
          }
        })
    },
    summaryProdId (val) {
      const body = {
        factoryPk: this.summaryFactory,
        projectPk: this.summaryProject,
        prodId: this.summaryProdId
      }
      this.resetFields()
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/hdrManufacturingDate?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.highlightedDates = res.data
            this.highlightedEndDates = res.data
          }
        })
      // this.highlightedDates = [
      //   { 'colorVolumeMindPoint': 1, 'manufacturingDate': '2025-08-01' },
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-01' }, // 同一天兩個 → 測紅色
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-05' },
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-08' },
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-11' },
      //   { 'colorVolumeMindPoint': 4, 'manufacturingDate': '2025-08-12' }, // 同一天兩個 → 測紅色
      //   { 'colorVolumeMindPoint': 1, 'manufacturingDate': '2025-08-15' },
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-18' },
      //   { 'colorVolumeMindPoint': 4, 'manufacturingDate': '2025-08-20' },
      //   { 'colorVolumeMindPoint': 4, 'manufacturingDate': '2025-08-25' },
      //   { 'colorVolumeMindPoint': 1, 'manufacturingDate': '2025-08-28' },
      //   { 'colorVolumeMindPoint': 3, 'manufacturingDate': '2025-08-28' } // 同一天兩個 → 測紅色
      // ]
      // this.highlightedEndDates = [
      //   { 'colorVolumeMindPoint': 1, 'manufacturingDate': '2025-08-01' },
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-01' }, // 同一天兩個 → 測紅色
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-05' },
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-08' },
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-11' },
      //   { 'colorVolumeMindPoint': 4, 'manufacturingDate': '2025-08-12' }, // 同一天兩個 → 測紅色
      //   { 'colorVolumeMindPoint': 1, 'manufacturingDate': '2025-08-15' },
      //   { 'colorVolumeMindPoint': 2, 'manufacturingDate': '2025-08-18' },
      //   { 'colorVolumeMindPoint': 4, 'manufacturingDate': '2025-08-20' },
      //   { 'colorVolumeMindPoint': 4, 'manufacturingDate': '2025-08-25' },
      //   { 'colorVolumeMindPoint': 1, 'manufacturingDate': '2025-08-28' },
      //   { 'colorVolumeMindPoint': 3, 'manufacturingDate': '2025-08-28' } // 同一天兩個 → 測紅色
      // ]
      if (this.isInitialPageLoad) {
        this.isInitialPageLoad = false
      }
    },

    summaryRangeStartDate (val) {
      this.summaryRangeStartDateMenu = false
      // this.startTimeMenu = true
    },
    // startTime (val) {
    //   if (this.startTimeMenuOperating > 0) {
    //     this.startTimeMenuOperating = 0
    //     this.startTimeMenu = false
    //   } else {
    //     this.startTimeMenuOperating = this.startTimeMenuOperating + 1
    //   }
    // },
    // startTimeMenu (val) {
    //   if (!val) {
    //     this.startTimeMenuOperating = 0
    //   }
    // },
    summaryRangeEndDate (val) {
      this.summaryRangeEndDateMenu = false
      // this.endTimeMenu = true
    },
    // endTime (val) {
    //   if (this.endTimeMenuOperating > 0) {
    //     this.endTimeMenuOperating = 0
    //     this.endTimeMenu = false
    //   } else {
    //     this.endTimeMenuOperating = this.endTimeMenuOperating + 1
    //   }
    // },
    // endTimeMenu (val) {
    //   if (!val) {
    //     this.endTimeMenuOperating = 0
    //   }
    // },
    checkTableShowList (val) {
      this.responseHeaders = JSON.parse(JSON.stringify(this.responseHeadersOnly))
      this.responseTableShowList = JSON.parse(JSON.stringify(this.responseTableShowListOnly))
      this.summaryTableShowList.forEach((s, index) => {
        this.checkTableShowList.forEach((c) => {
          this.responseTableShowList[c] = true
          if (s.value === c) {
            this.responseHeaders.push(this.responseHeadersList[index])
          }
        })
      })
    },
    // responseData (val) {
    //   this.pages = Math.ceil(this.totalRows / this.pagination.rowsPerPage)
    //   if (this.pages > 1) {
    //     setTimeout(() => {
    //       this.pagination.page = this.pages
    //     }, 0)
    //     setTimeout(() => {
    //       this.pagination.page = 1
    //     }, 100)
    //   } else {
    //     setTimeout(() => {
    //       this.pagination.rowsPerPage = 1
    //     }, 0)
    //     setTimeout(() => {
    //       this.pagination.rowsPerPage = this.perPageRows
    //     }, 100)
    //   }
    // },
    // perPageRows (val) {
    //   if (val === -1) {
    //     if (confirm('完整顯示將可能導致效能降低，是否仍完整顯示?')) {
    //       this.pagination.rowsPerPage = val
    //       this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
    //       this.pagination.page = 1
    //     } else {
    //       setTimeout(() => {
    //         this.perPageRows = this.pagination.rowsPerPage
    //       }, 100)
    //     }
    //   } else {
    //     this.pagination.rowsPerPage = val
    //     this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
    //     this.pagination.page = 1
    //   }
    // },
    'pagination.current.sortBy' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        // 让排序锁在本次事件循环后释放
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.current.descending' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.page': {
      handler (newName, oldName) {
        if (this.isSorting) return
        if (this.submit && !this.IsSubmitPage) {
          this.doLcdCalibrationDataList()
        }
      },
      immediate: true,
      deep: true
    },
    'pagination.current.rowsPerPage': {
      handler (newName, oldName) {
        console.info('this.IsSubmitPage:', this.IsSubmitPage)
        if (this.isSorting) return
        if (this.submit && !this.IsSubmitPage) {
          this.doLcdCalibrationDataList()
        }
      },
      immediate: true,
      deep: true
    },
    // 'pagination.page' (val) {
    //   this.checkList = []
    // },
    // 'pagination.rowsPerPage' (val) {
    //   this.checkList = []
    // },
    // 'pagination.sortBy' (val) {
    //   this.checkList = []
    // },
    // 'pagination.descending' (val) {
    //   this.checkList = []
    // }
    // summaryDate (val) {
    //   this.summaryDateMenu = false
    // },
    // summaryItem (val) {
    //   this.doSummary()
    // },
    // summaryRange (val) {
    //   this.doSummary()
    // }
    selectedDataType (newVal) {
      this.updateLuminanceOptions(newVal)
    },
    selectedLuminance_G (newVal) {
      this.updateModelGOptions(newVal)
    },
    selectedLuminance_C (newVal) {
      this.updateModelCOptions(newVal)
    },
    selectedColor_C (newVal) {
      this.updateColorOptions(newVal)
    },
    selectedgamut_Cov (newVal) {
      this.updategamutOptions(newVal)
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/lcd/lcdCalibrationAnalyzer')
      .then(response => {
        console.info(response)
        if (response.status === 'success' && response.data.accessible) {
          JSON.parse(localStorage.getItem('moduleDataInitDate')).forEach((n) => {
            if (n.name === 'lcd') {
              this.startdate = n.value
            }
          })
          this.$http.get('/api/lcd/analyzeMgmt/getSelectOptionData/factory').then(res => res.data)
            .then(res => {
              console.info(res)
              if (res.status === 'success') {
                this.summaryFactoryMenu = res.data
                console.info('this.summaryFactoryMenu', this.summaryFactoryMenu)
                if (this.tempFactory !== '') {
                  this.summaryFactory = this.tempFactory
                }
              }
            })
          if (this.$route.params.rangeStartDate && this.$route.params.rangeEndDate && this.$route.params.factory && this.$route.params.project && this.$route.params.calibrationType && this.$route.params.prodId && !this.isPageReload()) {
            this.summaryRangeStartDate = this.$route.params.rangeStartDate
            this.summaryRangeEndDate = this.$route.params.rangeEndDate
            this.tempFactory = Number(this.$route.params.factory)
            this.tempProject = Number(this.$route.params.project)
            this.tempCalibrationType = this.$route.params.calibrationType
            this.tempProdId = this.$route.params.prodId
          }
          // this.doResponseColumnDefine()
        } else if (response.errCode === 'E10000002') {
          JSON.parse(localStorage.getItem('moduleDataInitDate')).forEach((n) => {
            if (n.name === 'lcd') {
              this.startdate = n.value
            }
          })
          // if (this.$route.params.rangeStartDate && this.$route.params.rangeEndDate && this.$route.params.factory && this.$route.params.project && this.$route.params.calibrationType && this.$route.params.prodId) {
          //   this.summaryRangeStartDate = this.$route.params.rangeStartDate
          //   this.summaryRangeEndDate = this.$route.params.rangeEndDate
          //   this.tempFactory = Number(this.$route.params.factory)
          //   this.tempProject = Number(this.$route.params.project)
          //   this.tempCalibrationType = this.$route.params.calibrationType
          //   this.tempProdId = this.$route.params.prodId
          // }
          // this.$http.get('/api/lcd/analyzeMgmt/getSelectOptionData/factory').then(res => res.data)
          //   .then(res => {
          //     if (res.status === 'success') {
          //       this.summaryFactoryMenu = res.data
          //       if (this.tempFactory !== '') {
          //         this.summaryFactory = this.tempFactory
          //       }
          //     }
          //   })
          // this.doResponseColumnDefine()
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    _hashToIndex (str) {
      let h = 0
      for (let i = 0; i < str.length; i++) {
        h = (h << 5) - h + str.charCodeAt(i)
        h |= 0
      }
      return Math.abs(h)
    },

    // 同一個 point 永遠得到同一個顏色
    getColorForPoint (point) {
      const key = String(point)

      // 如果 override 有設定，直接取 override
      if (this.pointColorOverride[key]) {
        return this.pointColorOverride[key]
      }

      // 否則用 hash 決定顏色
      const idx = this._hashToIndex(key) % this.availableColors.length
      return this.availableColors[idx]
    },
    // exportToExcel () {
    //   // 確保有資料可匯出
    //   if (!this.responseData || this.responseData.length === 0) {
    //     alert('沒有資料可匯出')
    //     return
    //   }

    //   // 建立工作表數據（將數字轉為精確字串）
    //   const wsData = this.createExcelData()

    //   // 建立工作表
    //   const ws = XLSX.utils.aoa_to_sheet(wsData)

    //   // 設置所有列為文字格式（防止自動轉換）
    //   this.setAllColumnsAsText(ws, wsData[0].length)

    //   // 自動調整列寬
    //   const colWidths = this.responseColumnDefine.map(col => {
    //     return { wch: Math.min(Math.max(col.text.length, 8), 50) }
    //   })
    //   if (!ws['!cols']) ws['!cols'] = colWidths

    //   // 建立工作簿
    //   const wb = XLSX.utils.book_new()
    //   XLSX.utils.book_append_sheet(wb, ws, '資料匯出')

    //   // 生成檔案並下載
    //   const fileName = `精確資料匯出_${new Date().toISOString().slice(0, 10)}.xlsx`
    //   XLSX.writeFile(wb, fileName)
    // },
    // createExcelData () {
    //   // 表頭
    //   const headers = this.responseColumnDefine.map(col => col.text)

    //   // 數據行（特殊處理數字）
    //   const dataRows = this.responseData.map(item => {
    //     return this.responseColumnDefine.map(col => {
    //       const value = item[col.value]

    //       // 處理浮點數精度（保留原始值）
    //       if (typeof value === 'number') {
    //         // 轉換為字串保持原始精度
    //         return this.convertNumberToExactString(value)
    //       }

    //       // 處理物件類型
    //       if (typeof value === 'object' && value !== null) {
    //         return JSON.stringify(value)
    //       }

    //       return value
    //     })
    //   })

    //   return [headers, ...dataRows]
    // },

    // // 將數字轉換為精確字串表示
    // convertNumberToExactString (num) {
    //   // 檢查是否為整數
    //   if (Number.isInteger(num)) return num.toString()

    //   // 處理浮點數精度問題
    //   const str = num.toString()

    //   // 檢查科學計數法表示 (e.g., 1e-7)
    //   if (str.includes('e')) {
    //     // 轉換為固定小數表示
    //     return num.toLocaleString('fullwide', {
    //       useGrouping: false,
    //       maximumFractionDigits: 20
    //     })
    //   }

    //   // 直接返回字串表示
    //   return str
    // },

    // // 設置所有列為文字格式（防止Excel自動轉換）
    // setAllColumnsAsText (ws, columnCount) {
    //   const range = XLSX.utils.decode_range(ws['!ref'])

    //   // 遍歷所有單元格
    //   for (let row = range.s.r; row <= range.e.r; row++) {
    //     for (let col = 0; col < columnCount; col++) {
    //       const cellAddress = XLSX.utils.encode_cell({ r: row, c: col })

    //       // 獲取單元格
    //       if (!ws[cellAddress]) continue

    //       // 設置格式為文字（前綴 = 強制Excel識別為文字）
    //       if (typeof ws[cellAddress].v === 'string') {
    //         ws[cellAddress].t = 's' // 類型設為字串

    //         // 對數字字串添加前綴（防止自動轉換）
    //         if (!isNaN(ws[cellAddress].v) && ws[cellAddress].v !== '') {
    //           ws[cellAddress].v = "'" + ws[cellAddress].v
    //         }
    //       }
    //     }
    //   }
    // },
    flattenObject (obj, parentKey = '', result = {}) {
      for (var key in obj) {
        if (!obj.hasOwnProperty(key)) continue
        const newKey = key
        const value = obj[key]
        if (value && typeof value === 'object' && !Array.isArray(value)) {
        // 遞迴展開子物件
          this.flattenObject(value, newKey, result)
        } else {
          result[newKey] = value
        }
      }
      return result
    },
    resetFields () {
      this.biosSn = ''
      this.i1Sn = ''
      this.mfrid = ''
      this.mfrdate = ''
      this.errorCode = ''
      this.selectedDataType = ''
      this.selectedLuminance_G = ''
      this.selectedMode_G = ''
      this.dltpstart = ''
      this.dltpend = ''
      this.dtpstart = ''
      this.dtpend = ''
      this.lumistart = ''
      this.lumiend = ''
      this.selectedLuminance_C = ''
      this.selectedColor_C = ''
      this.selectedMode_C = ''
      this.selectedgamut_Cov = ''
      this.selectedMode_Cov = ''
    },
    naturalSortByValueKey (a, b) {
      return a.value.localeCompare(b.value, undefined, { numeric: true, sensitivity: 'base' })
    },
    isPageReload () {
      if (performance.getEntriesByType && performance.getEntriesByType('navigation').length > 0) {
        return performance.getEntriesByType('navigation')[0].type === 'reload'
      } else if (performance.navigation) {
        return performance.navigation.type === 1
      }
      return false
    },
    isNewPageEnter () {
      // 新瀏覽器使用 navigation entries
      if (performance.getEntriesByType && performance.getEntriesByType('navigation').length > 0) {
        const type = performance.getEntriesByType('navigation')[0].type
        return type === 'navigate' || type === 'back_forward'
      } else if (performance.navigation) {
        const type = performance.navigation.type
        // 0: navigate, 2: back_forward
        return type === 0 || type === 2
      }

      // fallback
      return false
    },
    extractFlatKeys (obj, parentKey = '') {
      const keys = []
      Object.entries(obj).forEach(([key, value]) => {
        if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          const subKeys = this.extractFlatKeys(value)
          keys.push(...subKeys)
        } else {
          keys.push(key)
        }
      })
      return keys
    },
    removeEmptyFields (obj) {
      Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') {
          this.removeEmptyFields(obj[key]) // 递归调用
          if (Object.keys(obj[key]).length === 0) {
            delete obj[key]
          }
        } else if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
          delete obj[key]
        }
      })
    },
    toggleDropdown () {
      this.dropdownVisible_Gray = !this.dropdownVisible_Gray // 切换下拉菜单的显示状态
      this.dropdownVisible_Color = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_ColorBox = false
      this.dropdownVisible_Cov = false
    },
    toggleDropdown_Color () {
      this.dropdownVisible_Color = !this.dropdownVisible_Color // 切换下拉菜单的显示状态
      this.dropdownVisible_Gray = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_ColorBox = false
      this.dropdownVisible_Cov = false
    },
    toggleDropdown_GrayBox () {
      this.dropdownVisible_GrayBox = !this.dropdownVisible_GrayBox // 切换下拉菜单的显示状态
      this.dropdownVisible_Gray = false // 切换下拉菜单的显示状态
      this.dropdownVisible_Color = false
      this.dropdownVisible_ColorBox = false
      this.dropdownVisible_Cov = false
    },
    toggleDropdown_ColorBox () {
      this.dropdownVisible_ColorBox = !this.dropdownVisible_ColorBox // 切换下拉菜单的显示状态
      this.dropdownVisible_Gray = false // 切换下拉菜单的显示状态
      this.dropdownVisible_Color = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_Cov = false
    },
    toggleDropdown_Cov () {
      this.dropdownVisible_Gray = false // 切换下拉菜单的显示状态
      this.dropdownVisible_Color = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_ColorBox = false
    },
    goTo2DGrayLink (nits) {
      window.open('/lcd/hdr/lcdCalibrationAnalyzer/showHDRLcdCalibration2DXYGray/' + nits, '_blank')
      this.dropdownVisible_Gray = false // 点击后隐藏下拉菜单
      this.dropdownVisible_Color = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_ColorBox = false
    },
    goTo2DColorLink (color) {
      window.open('/lcd/hdr/lcdCalibrationAnalyzer/showHDRLcdCalibration2DXYColor/' + color, '_blank')
      this.dropdownVisible_Gray = false // 点击后隐藏下拉菜单
      this.dropdownVisible_Color = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_ColorBox = false
    },

    goToGrayBoxLink (datatype) {
      window.open('/lcd/hdr/lcdCalibrationAnalyzer/showHDRLcdCalibrationGrayBoxChart/' + datatype, '_blank')
      this.dropdownVisible_Gray = false // 点击后隐藏下拉菜单
      this.dropdownVisible_Color = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_ColorBox = false
    },
    goToColorBoxLink (nits, datatype) {
      window.open('/lcd/hdr/lcdCalibrationAnalyzer/showHDRLcdCalibrationColorBoxChart/' + nits + '/' + datatype, '_blank')
      this.dropdownVisible_Gray = false // 点击后隐藏下拉菜单
      this.dropdownVisible_Color = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_ColorBox = false
    },
    goToCoverageLink (result) {
      window.open('/lcd/hdr/lcdCalibrationAnalyzer/showHDRLcdCalibrationCoverageChat', '_blank')
      this.dropdownVisible_Gray = false // 点击后隐藏下拉菜单
      this.dropdownVisible_Color = false
      this.dropdownVisible_GrayBox = false
      this.dropdownVisible_ColorBox = false
    },
    getEventColor (date) {
      // return this.highlightedDates.includes(date) ? 'green' : ''// 蓝色小圆点
      const records = this.highlightedDates.filter(d => d.manufacturingDate === date)
      console.info('records', records)
      if (records.length === 0) return ''

      // 取出 colorVolumeMindPoint 的唯一集合
      const uniquePoints = [...new Set(records.map(r => r.colorVolumeMindPoint))]
      console.info('uniquePoints', uniquePoints)
      // 如果有多種不同的 point → 紅色
      if (uniquePoints.length > 1) {
        return 'red'
      }

      // 單一種類 → 判斷顏色
      return this.getColorForPoint(uniquePoints[0])
    },
    getEndEventColor (date) {
      // return this.highlightedEndDates.includes(date) ? 'green' : ''// 蓝色小圆点
      // 找到所有同一天的紀錄
      const records = this.highlightedEndDates.filter(d => d.manufacturingDate === date)
      console.info('records', records)
      if (records.length === 0) return ''

      // 取出 colorVolumeMindPoint 的唯一集合
      const uniquePoints = [...new Set(records.map(r => r.colorVolumeMindPoint))]
      console.info('uniquePoints', uniquePoints)
      // 如果有多種不同的 point → 紅色
      if (uniquePoints.length > 1) {
        return 'red'
      }

      // 單一種類 → 判斷顏色
      return this.getColorForPoint(uniquePoints[0])
    },
    doResponseColumnDefine () {
      // this.responseHeaders.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      // this.responseHeadersOnly.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      console.log('responseColumnDefine:', this.responseColumnDefine)
      this.responseHeadersList = []
      this.responseHeaders = []
      this.responseHeadersOnly = []
      this.responseTableShowList = {}
      this.responseTableShowListOnly = {}
      this.responseColumnClassList = {}
      this.responseAlignList = {}
      this.summaryTableShowList = []
      this.responseColumnDefine.forEach((r) => {
        if (r.fixed) {
          this.responseHeaders.push(r)
          this.responseHeadersOnly.push(r)
        } else {
          this.responseHeadersList.push(r)
          this.responseTableShowList[r.value] = r.fixed
          this.responseTableShowListOnly[r.value] = r.fixed
          this.responseColumnClassList[r.value] = r.class
          this.responseAlignList[r.value] = r.align
          this.summaryTableShowList.push({ text: r.text, value: r.value })
        }
      })
      console.log('responseHeaders:', this.responseHeaders)
    },
    // doBeforeLink (TtrsPk, deviceSn) {
    //   this.$http.post('/api/thermal/getSingleDeviceBurnInDataStatistic?ttrsPk=' + TtrsPk).then(res => res.data)
    //     .then(res => {
    //       if (res.status === 'success') {
    //         let Groups = res.data.fanTestData.length
    //         const routeData = this.$router.resolve({ path: '/thermal/singleDeviceBurnInDataStatistic/' + TtrsPk + '/' + Groups, query: { sn: deviceSn, modelname: this.summaryCaseName, date: this.summaryDate, ems: this.summaryEMS } })
    //         window.open(routeData.href, '_blank')
    //       }
    //     })
    // },
    // doSummary (type) {
    //   this.barXaxisName = ['x']
    //   this.barXaxisValue = ['ModelName']
    //   let AllArray = []
    //   this.responseDataOnly.forEach((r) => {
    //     if (r[this.summaryItem] >= 0) {
    //       AllArray.push(r[this.summaryItem])
    //     }
    //   })
    //   this.RangeMax = Math.ceil(Math.max(...AllArray) / this.summaryRange) * this.summaryRange
    //   this.RangeMin = Math.floor(Math.min(...AllArray) / this.summaryRange) * this.summaryRange
    //   if (this.RangeMax > this.RangeMaxList[this.summaryItem]) {
    //     this.RangeMax = Math.min(this.RangeMax, this.RangeMaxList[this.summaryItem])
    //   }
    //   this.OverRangeCount = 0
    //   const RangeArray = []
    //   for (let i = this.RangeMin; i < this.RangeMax; i = i + this.summaryRange) {
    //     RangeArray[(i - this.RangeMin) / this.summaryRange] = 0
    //   }
    //   AllArray.forEach((r) => {
    //     if (r > this.RangeMaxList[this.summaryItem]) {
    //       this.OverRangeCount = this.OverRangeCount + 1
    //     } else {
    //       if (RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] > 0) {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] + 1
    //       } else {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = 1
    //       }
    //     }
    //   })

    //   this.RangeCount = Math.max(...RangeArray)
    //   for (let i = 0; i < RangeArray.length; i++) {
    //     this.barXaxisValue.push(RangeArray[i] || 0)
    //     switch (true) {
    //       case (this.summaryRange === '5' || this.summaryRange === '10'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(0) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(0))
    //         break
    //       case (this.summaryRange === '2.5' || this.summaryRange === '7.5'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(1) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(1))
    //         break
    //       // default:
    //       // return
    //     }
    //   }
    //   if (this.OverRangeCount > 0) {
    //     this.barXaxisValue.push(this.OverRangeCount)
    //     this.barXaxisName.push('>' + this.RangeMaxList[this.summaryItem])
    //   }
    //   // RangeArray.forEach((r, index) => {
    //   //   console.log(r)
    //   //   console.log(index)
    //   //   this.barXaxisValue.push(r)
    //   //   this.barXaxisName.push((this.RangeMin + (index * this.summaryRange)) + '-' + (this.RangeMin + ((index + 1) * this.summaryRange)))
    //   // })
    //   if (type === 'init') {
    //     this.handler_bar.$emit('init', this.options_bar)
    //   } else {
    //     this.handler_bar.$emit('dispatch', chart => {
    //       const options = {
    //         columns: [
    //           this.barXaxisName,
    //           this.barXaxisValue
    //         ]
    //       }
    //       chart.load(options)
    //     })
    //   }
    // },
    checkTableShowListAll () {
      this.checkTableShowList = []
      this.summaryTableShowList.forEach((s) => {
        this.checkTableShowList.push(s.value)
      })
    },
    checkTableShowListClear () {
      this.checkTableShowList = []
    },
    padDecimalToFourDigits (value) {
      if (value === null || value === undefined) return value

      const str = value.toString()
      const parts = str.split('.')
      if (parts.length === 1) {
        // 沒有小數點，加上 ".9999"
        return str + '.9999'
      }

      const decimalPart = parts[1]
      if (decimalPart.length >= 4) {
        // 已經滿4位，不動
        return str
      }

      // 補足到4位，補9
      const paddedDecimal = decimalPart.padEnd(4, '9')
      return `${parts[0]}.${paddedDecimal}`
    },
    doSubmit () {
      if (this.doSubmitVerification()) {
        this.loadingView = true
        this.pagination.page = 1
        this.pagination.current.rowsPerPage = 25
        this.doLcdCalibrationDataList()
        this.Get2DGray()
        this.GetBoxGray()
        this.Get2DColor()
        this.doLcdCalibrationSummaryInfo()
        this.doLcdCalibrationSaveFilterInfo()
        // setTimeout(() => {
        //   this.loadingView = false
        // }, 0)
        const Url = '/lcd/hdr/lcdCalibrationAnalyzer/' + this.summaryFactory + '/' + this.summaryProject + '/' + this.summaryCalibrationType + '/' + this.summaryProdId + '/' + this.summaryRangeStartDate + '/' + this.summaryRangeEndDate
        if (this.$router.history.current.path !== Url) {
          this.$router.replace(Url)
        }
        // this.resetFields()
      }
    },
    doSubmitVerification () {
      if (this.summaryFactory === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Factory'
        return false
      } else if (this.summaryProject === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Project'
        return false
      } else if (this.summaryCalibrationType === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Type'
        return false
      } else if (this.summaryProdId === '' || this.summaryProdId === 'NA') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇PROD ID'
        return false
      } else if (this.selectedDataType !== '' && this.selectedLuminance_G !== '' && this.selectedMode_G !== '' && (this.dltpstart === '' && this.dltpend === '' && this.dtpstart === '' && this.dtpend === '' && this.lumistart === '' && this.lumiend === '')) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請至少輸入一種range dlTP/dTP/Luminance'
        return false
      } else if (this.selectedDataType !== '' && this.selectedLuminance_C !== '' && this.selectedColor_C !== '' && this.selectedMode_C !== '' && (this.dltpstart === '' && this.dltpend === '' && this.dtpstart === '' && this.dtpend === '')) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請至少輸入一種range dlTP/dTP'
        return false
      } else if (this.selectedDataType !== '' && this.selectedgamut_Cov !== '' && this.selectedMode_Cov !== '' && (this.dltpstart === '' && this.dltpend === '')) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請至少輸入一種range'
        return false
      } if ((new Date(this.summaryRangeEndDate).getTime() < new Date(this.summaryRangeStartDate).getTime())) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '結尾時間不得早於起始時間'
        return false
      }
      const start = new Date(this.summaryRangeStartDate).getTime()
      const end = new Date(this.summaryRangeEndDate).getTime()
      const recordsInRange = this.highlightedEndDates.filter(item => {
        const d = new Date(item.manufactuingDate).getTime()
        return d >= start && d <= end
      })

      const pointsInRange = this.highlightedEndDates
        .filter(item => {
          const d = new Date(item.manufacturingDate).getTime()
          return d >= start && d <= end
        })
        .map(item => String(item.colorVolumeMindPoint))

      const uniquePoints = [...new Set(pointsInRange)]
      if (uniquePoints.length > 1) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '所選日期區間內存在多種 colorVolumeMindPoint'
        return false
      }

      // 2️⃣ 檢查是否有紅色點 (同一天多個 point)
      const groupedByDate = {}
      recordsInRange.forEach(r => {
        const d = this.formatDate(r.manufactuingDate)
        if (!groupedByDate[d]) groupedByDate[d] = new Set()
        groupedByDate[d].add(String(r.colorVolumeMindPoint))
      })

      const hasRedDot = Object.values(groupedByDate).some(pointsSet => pointsSet.size > 1)
      if (hasRedDot) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '所選日期區間內存在紅色點（同一天多個 colorVolumeMindPoint）'
        return false
      }

      return true
    },
    doLcdCalibrationSaveFilterInfo () {
      // this.grayLevelRangeFilter.mode = this.selectedMode_G
      // this.grayLevelRangeFilter.pqCode = this.selectedLuminance_G
      // this.grayLevelRangeFilter.ditpRange.min = this.dltpstart
      // this.grayLevelRangeFilter.ditpRange.max = this.dltpend
      // this.grayLevelRangeFilter.dtpRange.min = this.dtpstart
      // this.grayLevelRangeFilter.dtpRange.max = this.dtpend
      // this.grayLevelRangeFilter.luminanceRange.min = this.lumistart
      // this.grayLevelRangeFilter.luminanceRange.max = this.lumiend
      // this.colorVolumeRangeFilter.mode = this.selectedMode_C
      // this.colorVolumeRangeFilter.luminance = this.selectedLuminance_C
      // this.colorVolumeRangeFilter.color = this.selectedMode_G
      // this.colorVolumeRangeFilter.ditpRange.min = this.dltpstart
      // this.colorVolumeRangeFilter.ditpRange.max = this.dltpend
      // this.colorVolumeRangeFilter.dtpRange.min = this.dtpstart
      // this.colorVolumeRangeFilter.dtpRange.max = this.dtpend
      // this.coverageRangeFilter.mode = this.selectedMode_Cov
      // this.coverageRangeFilter.gamut = this.selectedgamut_Cov
      // this.coverageRangeFilter.range.min = this.dltpstart
      // this.coverageRangeFilter.range.max = this.dltpend
      this.grayLevelRangeFilter = {
        mode: this.selectedMode_G || undefined,
        pqCode: this.selectedLuminance_G || undefined,
        ditpRange: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        },
        dtpRange: {
          min: this.dtpstart || undefined,
          max: this.dtpend || undefined
        },
        luminanceRange: {
          min: this.lumistart !== undefined && this.lumistart !== '' ? this.lumistart / 100 : undefined,
          max: this.lumiend !== undefined && this.lumiend !== '' ? this.lumiend / 100 : undefined
        }

      }

      this.colorVolumeRangeFilter = {
        mode: this.selectedMode_C || undefined,
        luminance: this.selectedLuminance_C || undefined,
        color: this.selectedColor_C || undefined,
        ditpRange: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        },
        dtpRange: {
          min: this.dtpstart || undefined,
          max: this.dtpend || undefined
        }
      }

      this.coverageRangeFilter = {
        mode: this.selectedMode_Cov || undefined,
        gamut: this.selectedgamut_Cov || undefined,
        range: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        }
      }
      function removeEmptyFields (obj) {
        Object.keys(obj).forEach(key => {
          if (obj[key] && typeof obj[key] === 'object') {
            removeEmptyFields(obj[key])
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key]
            }
          } else if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
            delete obj[key]
          }
        })
      }

      removeEmptyFields(this.grayLevelRangeFilter)
      removeEmptyFields(this.colorVolumeRangeFilter)
      removeEmptyFields(this.coverageRangeFilter)
      const body = {
        factoryPk: this.summaryFactory,
        factoryName: this.summaryFactoryMenu[this.summaryFactoryMenu.map(e => { return e.value }).indexOf(this.summaryFactory)].text || null,
        projectPk: this.summaryProject,
        projectName: this.summaryProjectMenu[this.summaryProjectMenu.map(e => { return e.value }).indexOf(this.summaryProject)].text || null,
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate,
        prodId: this.summaryProdId
        // i1Sn: this.i1Sn,
        // mfrid: this.mfrid,
        // mfrdate: this.mfrdate
        // ...this.grayLevelRangeFilter,
        // ...this.colorVolumeRangeFilter,
        // ...this.coverageRangeFilter
        // biosSn: this.biosSn,
        // errorCode: this.errorCode,
        // i1Sn: this.i1Sn,
        // mfrid: this.mfrid,
        // mfrdate: this.mfrdate,
        // yRangeStart: this.yRangeStart,
        // yRangeEnd: this.yRangeEnd,
        // yRangeType: this.yRangeType,
        // gammaRangeStart: this.gammaRangeStart,
        // gammaRangeEnd: this.gammaRangeEnd,
        // gammaDiffRangeStart: this.gammaDiffRangeStart,
        // gammaDiffRangeEnd: this.gammaDiffRangeEnd,
        // xCoordinateRangeStart: this.xCoordinateRangeStart,
        // xCoordinateRangeEnd: this.xCoordinateRangeEnd,
        // yCoordinateRangeStart: this.yCoordinateRangeStart,
        // yCoordinateRangeEnd: this.yCoordinateRangeEnd,
        // xyCoordinateRangeType: this.xyCoordinateRangeType
      }
      // 根据用户选择的 selectedDataType 添加对应的过滤条件
      if (this.selectedDataType === 'grayLevel') {
        body.grayLevelRangeFilter = this.grayLevelRangeFilter
      } else if (this.selectedDataType === 'colorVolume') {
        body.colorVolumeRangeFilter = this.colorVolumeRangeFilter
      } else if (this.selectedDataType === 'coverage') {
        body.coverageRangeFilter = this.coverageRangeFilter
      }

      if (this.biosSn) {
        body.isn = this.biosSn
      }
      if (this.i1Sn) {
        body.i1Sn = this.i1Sn
      }
      if (this.mfrid) {
        body.mfrid = this.mfrid
      }
      if (this.mfrdate) {
        body.mfrdate = this.mfrdate
      }
      if (this.errorCode) {
        body.errorCode = this.errorCode
      }
      localStorage.setItem('hdrlcdFilterInfo', JSON.stringify(body))
      // localStorage.setItem('lcdFilterUpdateTime', this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
    },
    Get2DGray () {
      const body = {
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate
      }
      this.Gray2DList = []
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/luminance/grayLevel/${this.summaryProject}/${this.summaryProdId}?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.Gray2DList = res.data.map(item => ({ text: item.text, value: item.value }))
          }
        })
    },
    GetBoxGray () {
      const body = {
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate
      }
      this.colorColorBoxList = []
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/luminance/colorVolume/${this.summaryProject}/${this.summaryProdId}?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            res.data.forEach(item => {
              this.colorColorBoxList.push(
                { text: `${item.value}Nits_dITP`, value: item.value, type: 'dITP' },
                { text: `${item.value}Nits_dTP`, value: item.value, type: 'dTP' }
              )
            })
          }
        })
    },
    Get2DColor () {
      const body = {
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate
      }
      this.color2DList = []
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/color/${this.summaryProject}/${this.summaryProdId}?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          console.info('colorres', res)
          if (res.status === 'success') {
            for (let i = 0; i <= res.data; i++) {
              this.color2DList.push({
                text: `Color ${i}`,
                value: i
              })
            }
          }
        })
    },
    doLcdCalibrationSummaryInfo () {
      // this.grayLevelRangeFilter.mode = this.selectedMode_G
      // this.grayLevelRangeFilter.pqCode = this.selectedLuminance_G
      // this.grayLevelRangeFilter.ditpRange.min = this.dltpstart
      // this.grayLevelRangeFilter.ditpRange.max = this.dltpend
      // this.grayLevelRangeFilter.dtpRange.min = this.dtpstart
      // this.grayLevelRangeFilter.dtpRange.max = this.dtpend
      // this.grayLevelRangeFilter.luminanceRange.min = this.lumistart
      // this.grayLevelRangeFilter.luminanceRange.max = this.lumiend
      // this.colorVolumeRangeFilter.mode = this.selectedMode_C
      // this.colorVolumeRangeFilter.luminance = this.selectedLuminance_C
      // this.colorVolumeRangeFilter.color = this.selectedMode_G
      // this.colorVolumeRangeFilter.ditpRange.min = this.dltpstart
      // this.colorVolumeRangeFilter.ditpRange.max = this.dltpend
      // this.colorVolumeRangeFilter.dtpRange.min = this.dtpstart
      // this.colorVolumeRangeFilter.dtpRange.max = this.dtpend
      // this.coverageRangeFilter.mode = this.selectedMode_Cov
      // this.coverageRangeFilter.gamut = this.selectedgamut_Cov
      // this.coverageRangeFilter.range.min = this.dltpstart
      // this.coverageRangeFilter.range.max = this.dltpend
      this.grayLevelRangeFilter = {
        mode: this.selectedMode_G || undefined,
        pqCode: this.selectedLuminance_G || undefined,
        ditpRange: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        },
        dtpRange: {
          min: this.dtpstart || undefined,
          max: this.dtpend || undefined
        },
        luminanceRange: {
          min: this.lumistart !== undefined && this.lumistart !== '' ? this.lumistart / 100 : undefined,
          max: this.lumiend !== undefined && this.lumiend !== '' ? this.lumiend / 100 : undefined
        }
      }

      this.colorVolumeRangeFilter = {
        mode: this.selectedMode_C || undefined,
        luminance: this.selectedLuminance_C || undefined,
        color: this.selectedColor_C || undefined,
        ditpRange: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        },
        dtpRange: {
          min: this.dtpstart || undefined,
          max: this.dtpend || undefined
        }
      }

      this.coverageRangeFilter = {
        mode: this.selectedMode_Cov || undefined,
        gamut: this.selectedgamut_Cov || undefined,
        range: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        }
      }
      function removeEmptyFields (obj) {
        Object.keys(obj).forEach(key => {
          if (obj[key] && typeof obj[key] === 'object') {
            removeEmptyFields(obj[key])
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key]
            }
          } else if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
            delete obj[key]
          }
        })
      }

      removeEmptyFields(this.grayLevelRangeFilter)
      removeEmptyFields(this.colorVolumeRangeFilter)
      removeEmptyFields(this.coverageRangeFilter)
      const body = {
        // pageNum: this.pagination.page,
        // pageRows: this.pagination.current.rowsPerPage,
        // sortColumn: (this.pagination.current.descending !== null) ? this.pagination.current.sortBy : '',
        // sortType: this.pagination.current.descending ? 'DESC' : ((this.pagination.current.descending !== null) ? 'ASC' : ''),
        factoryPk: this.summaryFactory,
        projectPk: this.summaryProject,
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate,
        prodId: this.summaryProdId
        // i1Sn: this.i1Sn,
        // mfrid: this.mfrid,
        // mfrdate: this.mfrdate
        // ...this.grayLevelRangeFilter,
        // ...this.colorVolumeRangeFilter,
        // ...this.coverageRangeFilter
        // biosSn: this.biosSn,
        // errorCode: this.errorCode,
        // i1Sn: this.i1Sn,
        // mfrid: this.mfrid,
        // mfrdate: this.mfrdate,
        // yRangeStart: this.yRangeStart,
        // yRangeEnd: this.yRangeEnd,
        // yRangeType: this.yRangeType,
        // gammaRangeStart: this.gammaRangeStart,
        // gammaRangeEnd: this.gammaRangeEnd,
        // gammaDiffRangeStart: this.gammaDiffRangeStart,
        // gammaDiffRangeEnd: this.gammaDiffRangeEnd,
        // xCoordinateRangeStart: this.xCoordinateRangeStart,
        // xCoordinateRangeEnd: this.xCoordinateRangeEnd,
        // yCoordinateRangeStart: this.yCoordinateRangeStart,
        // yCoordinateRangeEnd: this.yCoordinateRangeEnd,
        // xyCoordinateRangeType: this.xyCoordinateRangeType
      }
      // console.info(body)
      if (this.selectedDataType === 'grayLevel') {
        body.grayLevelRangeFilter = this.grayLevelRangeFilter
      } else if (this.selectedDataType === 'colorVolume') {
        body.colorVolumeRangeFilter = this.colorVolumeRangeFilter
      } else if (this.selectedDataType === 'coverage') {
        body.coverageRangeFilter = this.coverageRangeFilter
      }

      if (this.biosSn) {
        body.isn = this.biosSn
      }
      if (this.i1Sn) {
        body.i1Sn = this.i1Sn
      }
      if (this.mfrid) {
        body.mfrid = this.mfrid
      }
      if (this.mfrdate) {
        body.mfrdate = this.mfrdate
      }
      if (this.errorCode) {
        body.errorCode = this.errorCode
      }
      // console.log('Request Body:', JSON.stringify(body, null, 2))

      this.$http.post('/api/lcd/analyzeMgmt/lcdCalibrationHdrSummaryInfo', body).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.passAmount = String(res.data.passAmount)
            this.failAmount = String(res.data.failAmount)
            this.totalTestInputs = String(res.data.totalTestInputs)
            this.loadingView = false
          }
        })
    },
    doLcdCalibrationDataList () {
      this.submit = true
      // this.grayLevelRangeFilter.mode = this.selectedMode_G
      // this.grayLevelRangeFilter.pqCode = this.selectedLuminance_G
      // this.grayLevelRangeFilter.ditpRange.min = this.dltpstart
      // this.grayLevelRangeFilter.ditpRange.max = this.dltpend
      // this.grayLevelRangeFilter.dtpRange.min = this.dtpstart
      // this.grayLevelRangeFilter.dtpRange.max = this.dtpend
      // this.grayLevelRangeFilter.luminanceRange.min = this.lumistart
      // this.grayLevelRangeFilter.luminanceRange.max = this.lumiend
      // this.colorVolumeRangeFilter.mode = this.selectedMode_C
      // this.colorVolumeRangeFilter.luminance = this.selectedLuminance_C
      // this.colorVolumeRangeFilter.color = this.selectedMode_G
      // this.colorVolumeRangeFilter.ditpRange.min = this.dltpstart
      // this.colorVolumeRangeFilter.ditpRange.max = this.dltpend
      // this.colorVolumeRangeFilter.dtpRange.min = this.dtpstart
      // this.colorVolumeRangeFilter.dtpRange.max = this.dtpend
      // this.coverageRangeFilter.mode = this.selectedMode_Cov
      // this.coverageRangeFilter.gamut = this.selectedgamut_Cov
      // this.coverageRangeFilter.range.min = this.dltpstart
      // this.coverageRangeFilter.range.max = this.dltpend
      this.grayLevelRangeFilter = {
        mode: this.selectedMode_G || undefined,
        pqCode: this.selectedLuminance_G || undefined,
        ditpRange: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        },
        dtpRange: {
          min: this.dtpstart || undefined,
          max: this.dtpend || undefined
        },
        luminanceRange: {
          min: this.lumistart !== undefined && this.lumistart !== '' ? this.lumistart / 100 : undefined,
          max: this.lumiend !== undefined && this.lumiend !== '' ? this.lumiend / 100 : undefined
        }
      }

      this.colorVolumeRangeFilter = {
        mode: this.selectedMode_C || undefined,
        luminance: this.selectedLuminance_C || undefined,
        color: this.selectedColor_C || undefined,
        ditpRange: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        },
        dtpRange: {
          min: this.dtpstart || undefined,
          max: this.dtpend || undefined
        }
      }

      this.coverageRangeFilter = {
        mode: this.selectedMode_Cov || undefined,
        gamut: this.selectedgamut_Cov || undefined,
        range: {
          min: this.dltpstart || undefined,
          max: this.dltpend || undefined
        }
      }
      function removeEmptyFields (obj) {
        Object.keys(obj).forEach(key => {
          if (obj[key] && typeof obj[key] === 'object') {
            removeEmptyFields(obj[key])
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key]
            }
          } else if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
            delete obj[key]
          }
        })
      }

      removeEmptyFields(this.grayLevelRangeFilter)
      removeEmptyFields(this.colorVolumeRangeFilter)
      removeEmptyFields(this.coverageRangeFilter)
      const body = {
        pageNum: this.pagination.page,
        pageRows: this.pagination.current.rowsPerPage,
        sortColumn: (this.pagination.current.descending !== null) ? this.pagination.current.sortBy : '',
        sortType: this.pagination.current.descending ? 'DESC' : ((this.pagination.current.descending !== null) ? 'ASC' : ''),
        factoryPk: this.summaryFactory,
        projectPk: this.summaryProject,
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate,
        prodId: this.summaryProdId
        // i1Sn: this.i1Sn,
        // mfrid: this.mfrid,
        // mfrdate: this.mfrdate
        // ...this.grayLevelRangeFilter,
        // ...this.colorVolumeRangeFilter,
        // ...this.coverageRangeFilter

        // biosSn: this.biosSn,
        // errorCode: this.errorCode,
        // i1Sn: this.i1Sn,
        // mfrid: this.mfrid,
        // mfrdate: this.mfrdate,
        // yRangeStart: this.yRangeStart,
        // yRangeEnd: this.yRangeEnd,
        // yRangeType: this.yRangeType,
        // gammaRangeStart: this.gammaRangeStart,
        // gammaRangeEnd: this.gammaRangeEnd,
        // gammaDiffRangeStart: this.gammaDiffRangeStart,
        // gammaDiffRangeEnd: this.gammaDiffRangeEnd,
        // xCoordinateRangeStart: this.xCoordinateRangeStart,
        // xCoordinateRangeEnd: this.xCoordinateRangeEnd,
        // yCoordinateRangeStart: this.yCoordinateRangeStart,
        // yCoordinateRangeEnd: this.yCoordinateRangeEnd,
        // xyCoordinateRangeType: this.xyCoordinateRangeType
      }
      if (this.selectedDataType === 'grayLevel') {
        body.grayLevelRangeFilter = this.grayLevelRangeFilter
      } else if (this.selectedDataType === 'colorVolume') {
        body.colorVolumeRangeFilter = this.colorVolumeRangeFilter
      } else if (this.selectedDataType === 'coverage') {
        body.coverageRangeFilter = this.coverageRangeFilter
      }
      if (this.biosSn) {
        body.isn = this.biosSn
      }
      if (this.i1Sn) {
        body.i1Sn = this.i1Sn
      }
      if (this.mfrid) {
        body.mfrid = this.mfrid
      }
      if (this.mfrdate) {
        body.mfrdate = this.mfrdate
      }
      if (this.errorCode) {
        body.errorCode = this.errorCode
      }
      console.info(body)
      this.$http.post('/api/lcd/analyzeMgmt/lcdCalibrationHdrDataList', body).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.status === 'success') {
            // this.pagination.rowsPerPage = res.data.length
            // const firstItem = res.data.pagingList[0]
            // Object.entries(firstItem).forEach(([key, value]) => {
            //   if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
            //     // 是物件，展開印出
            //     Object.entries(value).forEach(([subKey, subValue]) => {
            //       console.info(`${key}.${subKey}: ${subValue}`)
            //     })
            //   } else {
            //     // 基本型別或陣列，直接印出
            //     console.info(`${key}: ${value}`)
            //   }
            // })
            this.checkTableInputDefine = []
            const deleteIndex = this.responseColumnDefine.findIndex(col => col.text === '操作')
            console.info('this.deleteIndex', deleteIndex)
            if (deleteIndex !== -1) {
              // 从操作列索引开始，删除后面所有元素
              this.responseColumnDefine.splice(deleteIndex + 1)
            }
            console.info('this.responseColumnDefine', this.responseColumnDefine)
            this.responseData = res.data.pagingList
            this.responseDataOnly = res.data.pagingList

            // 取得 responseData 的所有欄位名稱
            let responseDataKeys = this.extractFlatKeys(this.responseData[0])

            // 取得 checkTableInputDefine 和 responseColumnDefine 現有的 value 列表
            let existingResponseValues = this.responseColumnDefine.map(item => item.value)

            // 遍歷 responseDataKeys，檢查是否需要新增欄位
            responseDataKeys.forEach(key => {
              if (!existingResponseValues.includes(key) && key !== 'pk') {
                const width = key.length < 5
                  ? 100
                  : key.length <= 10
                    ? 150
                    : 200
                this.responseColumnDefine.push({
                  align: '',
                  class: `table-width-${width}`,
                  fixed: false,
                  sortable: true,
                  text: key,
                  value: key
                })
                this.checkTableInputDefine.push({ text: key, value: key })
              }
            })
            this.responseData = res.data.pagingList.map(item => this.flattenObject(item))
            this.responseDataOnly = [...this.responseData]
            console.info('this.checkTableInputDefine', this.checkTableInputDefine)
            // 對 responseColumnDefine 排序
            const operationIndex = this.responseColumnDefine.findIndex(col => col.text === '操作')

            let operationColumns = []
            let otherColumns = []

            if (operationIndex !== -1) {
              operationColumns = this.responseColumnDefine.slice(0, operationIndex + 1)
              otherColumns = this.responseColumnDefine.slice(operationIndex + 1)
            } else {
              // 沒有操作欄位，全部當作 otherColumns
              otherColumns = [...this.responseColumnDefine]
            }
            console.info('operationColumns', operationColumns)
            console.info('otherColumns', otherColumns)
            // 對非操作欄排序
            otherColumns.sort(this.naturalSortByValueKey)

            // 合併結果：先放其他欄位，再放操作欄位
            this.responseColumnDefine = [...operationColumns, ...otherColumns]

            // 對 checkTableInputDefine 排序
            this.checkTableInputDefine.sort(this.naturalSortByValueKey)
            this.checkTableShowListClear()
            this.doResponseColumnDefine()
            // res.data.deviceList.forEach((r, index) => {
            //   this.responseData.push({})
            //   r.forEach((rr) => {
            //     this.responseData[index][rr.name] = rr.value
            //   })
            //   this.responseDataOnly.push({})
            //   r.forEach((rr) => {
            //     this.responseDataOnly[index][rr.name] = rr.value
            //   })
            // })
            this.pagination.current.totalItems = Number(res.data.totalRows)
            // this.pages = Math.ceil(res.data.totalRows / this.pagination.current.rowsPerPage)
            this.IsSubmitPage = true
            // this.pagination.current.totalItems = res.data.totalRows
            // this.pagination.rowsPerPage = 25
            // this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
            // setTimeout(() => {
            //   this.pages = Math.ceil(res.data.totalRows / this.pagination.current.rowsPerPage)
            // }, 0)
          }
          return res
        })
        .then(res => {
          if (res.status === 'success') {
            this.pages = Number(Math.ceil(res.data.totalRows / this.pagination.current.rowsPerPage))
            this.IsSubmitPage = false
          }
        })
    },
    downloadXLS () {
      if (this.doSubmitVerification()) {
        this.processingView = true
        // this.grayLevelRangeFilter.mode = this.selectedMode_G
        // this.grayLevelRangeFilter.pqCode = this.selectedLuminance_G
        // this.grayLevelRangeFilter.ditpRange.min = this.dltpstart
        // this.grayLevelRangeFilter.ditpRange.max = this.dltpend
        // this.grayLevelRangeFilter.dtpRange.min = this.dtpstart
        // this.grayLevelRangeFilter.dtpRange.max = this.dtpend
        // this.grayLevelRangeFilter.luminanceRange.min = this.lumistart
        // this.grayLevelRangeFilter.luminanceRange.max = this.lumiend
        // this.colorVolumeRangeFilter.mode = this.selectedMode_C
        // this.colorVolumeRangeFilter.luminance = this.selectedLuminance_C
        // this.colorVolumeRangeFilter.color = this.selectedMode_G
        // this.colorVolumeRangeFilter.ditpRange.min = this.dltpstart
        // this.colorVolumeRangeFilter.ditpRange.max = this.dltpend
        // this.colorVolumeRangeFilter.dtpRange.min = this.dtpstart
        // this.colorVolumeRangeFilter.dtpRange.max = this.dtpend
        // this.coverageRangeFilter.mode = this.selectedMode_Cov
        // this.coverageRangeFilter.gamut = this.selectedgamut_Cov
        // this.coverageRangeFilter.range.min = this.dltpstart
        // this.coverageRangeFilter.range.max = this.dltpend
        this.grayLevelRangeFilter = {
          mode: this.selectedMode_G || undefined,
          pqCode: this.selectedLuminance_G || undefined,
          ditpRange: {
            min: this.dltpstart || undefined,
            max: this.dltpend || undefined
          },
          dtpRange: {
            min: this.dtpstart || undefined,
            max: this.dtpend || undefined
          },
          luminanceRange: {
            min: this.lumistart !== undefined && this.lumistart !== '' ? this.lumistart / 100 : undefined,
            max: this.lumiend !== undefined && this.lumiend !== '' ? this.lumiend / 100 : undefined
          }
        }

        this.colorVolumeRangeFilter = {
          mode: this.selectedMode_C || undefined,
          luminance: this.selectedLuminance_C || undefined,
          color: this.selectedColor_C || undefined,
          ditpRange: {
            min: this.dltpstart || undefined,
            max: this.dltpend || undefined
          },
          dtpRange: {
            min: this.dtpstart || undefined,
            max: this.dtpend || undefined
          }
        }

        this.coverageRangeFilter = {
          mode: this.selectedMode_Cov || undefined,
          gamut: this.selectedgamut_Cov || undefined,
          range: {
            min: this.dltpstart || undefined,
            max: this.dltpend || undefined
          }
        }
        this.removeEmptyFields(this.grayLevelRangeFilter)
        this.removeEmptyFields(this.colorVolumeRangeFilter)
        this.removeEmptyFields(this.coverageRangeFilter)

        const body = {
          // pageNum: this.pagination.page,
          // pageRows: this.pagination.current.rowsPerPage,
          // sortColumn: (this.pagination.current.descending !== null) ? this.pagination.current.sortBy : '',
          // sortType: this.pagination.current.descending ? 'DESC' : ((this.pagination.current.descending !== null) ? 'ASC' : ''),
          factoryPk: this.summaryFactory,
          projectPk: this.summaryProject,
          startTime: this.summaryRangeStartDate,
          endTime: this.summaryRangeEndDate,
          prodId: this.summaryProdId
          // i1Sn: this.i1Sn,
          // mfrid: this.mfrid,
          // mfrdate: this.mfrdate
          // ...this.grayLevelRangeFilter,
          // ...this.colorVolumeRangeFilter,
          // ...this.coverageRangeFilter
          // biosSn: this.biosSn,
          // errorCode: this.errorCode,
          // i1Sn: this.i1Sn,
          // mfrid: this.mfrid,
          // mfrdate: this.mfrdate,
          // yRangeStart: this.yRangeStart,
          // yRangeEnd: this.yRangeEnd,
          // yRangeType: this.yRangeType,
          // gammaRangeStart: this.gammaRangeStart,
          // gammaRangeEnd: this.gammaRangeEnd,
          // gammaDiffRangeStart: this.gammaDiffRangeStart,
          // gammaDiffRangeEnd: this.gammaDiffRangeEnd,
          // xCoordinateRangeStart: this.xCoordinateRangeStart,
          // xCoordinateRangeEnd: this.xCoordinateRangeEnd,
          // yCoordinateRangeStart: this.yCoordinateRangeStart,
          // yCoordinateRangeEnd: this.yCoordinateRangeEnd,
          // xyCoordinateRangeType: this.xyCoordinateRangeType
        }
        if (this.selectedDataType === 'grayLevel') {
          body.grayLevelRangeFilter = this.grayLevelRangeFilter
        } else if (this.selectedDataType === 'colorVolume') {
          body.colorVolumeRangeFilter = this.colorVolumeRangeFilter
        } else if (this.selectedDataType === 'coverage') {
          body.coverageRangeFilter = this.coverageRangeFilter
        }
        if (this.biosSn) {
          body.isn = this.biosSn
        }
        if (this.i1Sn) {
          body.i1Sn = this.i1Sn
        }
        if (this.mfrid) {
          body.mfrid = this.mfrid
        }
        if (this.mfrdate) {
          body.mfrdate = this.mfrdate
        }
        if (this.errorCode) {
          body.errorCode = this.errorCode
        }
        console.log('Request Body:', JSON.stringify(body, null, 2))
        this.$http.post(`/api/lcd/analyzeMgmt/lcdCalibrationHdrRawdata.xls`, body, { responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        })
          .then(res => {
            console.info(res)
            this.processingView = false
            if (res.data.type === 'application/json') {
              return new Promise((resolve, reject) => {
                const reader = new FileReader()

                reader.onload = () => {
                  res.data = JSON.parse(reader.result)
                  if (res.data.status === 'success') {
                    alert(res.data.data)
                    // resolve(Promise.reject(res.data.data))
                  } else {
                    this.snackbar = true
                    this.snackbarColor = 'red'
                    this.snackbarMsg = res.data.errMsg + ' (' + res.data.errCode + ')'
                  }
                }
                reader.onerror = () => {
                  reject(res.data.errMsg || res.data.data)
                }
                reader.readAsText(res.data)
              })
            } else if (res.data.status !== 'failure' && res.headers['content-disposition']) {
              const blob = new Blob([res.data], { type: 'application/octet-stream' })
              const url = window.URL.createObjectURL(blob)
              const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
              const downloadLink = document.createElement('a')
              downloadLink.href = url
              downloadLink.download = fileName

              document.body.appendChild(downloadLink)
              downloadLink.click()
              document.body.removeChild(downloadLink)
            } else {
              this.snackbar = true
              this.snackbarColor = 'red'
              this.snackbarMsg = '下載失敗，請通知系統管理員'
            }
          })
          .catch(err => {
            this.processingView = false
            this.snackbar = true
            this.snackbarColor = 'orange'
            this.snackbarMsg = err
          })
      }
    },
    downloadNBreport (pk) {
      this.processingView = true
      this.$http.get(`/api/lcd/analyzeMgmt/hdrHitraceLog/${pk}`, {}, { responseType: 'blob' })
        .then(res => {
          this.processingView = false
          if (res.data.type === 'application/json') {
            return new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onload = () => {
                res.data = JSON.parse(reader.result)
                if (res.data.status === 'success') {
                  alert(res.data.data)
                } else {
                  this.snackbar = true
                  this.snackbarColor = 'red'
                  this.snackbarMsg = res.data.errMsg + ' (' + res.data.errCode + ')'
                }
              }
              reader.onerror = () => {
                reject(res.data.errMsg || res.data.data)
              }
              reader.readAsText(res.data)
            })
          } else if (res.data.status !== 'failure' && res.headers['content-disposition']) {
            const blob = new Blob([res.data], { type: 'application/octet-stream' })
            const url = window.URL.createObjectURL(blob)
            const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
            const downloadLink = document.createElement('a')
            downloadLink.href = url
            downloadLink.download = fileName

            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          } else {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '下載失敗，請通知系統管理員'
          }
        })
        .catch(err => {
          this.processingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    downloadHitTraceLog (pk) {
      this.processingView = true
      this.$http.get(`/api/lcd/analyzeMgmt/hdrNbReport/${pk}`, {}, { responseType: 'blob' })
        .then(res => {
          this.processingView = false
          if (res.data.type === 'application/json') {
            return new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onload = () => {
                res.data = JSON.parse(reader.result)
                if (res.data.status === 'success') {
                  alert(res.data.data)
                } else {
                  this.snackbar = true
                  this.snackbarColor = 'red'
                  this.snackbarMsg = res.data.errMsg + ' (' + res.data.errCode + ')'
                }
              }

              reader.onerror = () => {
                reject(res.data.errMsg || res.data.data)
              }
              reader.readAsText(res.data)
            })
          } else if (res.data.status !== 'failure' && res.headers['content-disposition']) {
            const blob = new Blob([res.data], { type: 'application/octet-stream' })
            const url = window.URL.createObjectURL(blob)
            const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
            const downloadLink = document.createElement('a')
            downloadLink.href = url
            downloadLink.download = fileName

            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
          } else {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '下載失敗，請通知系統管理員'
          }
        })
        .catch(err => {
          this.processingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    updateLuminanceOptions (dataType) {
      if (this.summaryFactory === '') {
        this.selectedDataType = ''
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Factory'
        return false
      } else if (this.summaryProject === '') {
        this.selectedDataType = ''
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Project'
        return false
      } else if (this.summaryCalibrationType === '') {
        this.selectedDataType = ''
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Type'
        return false
      } else if (this.summaryProdId === '' || this.summaryProdId === 'NA') {
        this.selectedDataType = ''
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇PROD ID'
        return false
      }
      // 根据选中的 Data Type 模拟更新 Luminance 的选项
      if (dataType === 'grayLevel') {
        const body = {
          startTime: this.summaryRangeStartDate,
          endTime: this.summaryRangeEndDate
        }
        this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/luminance/` + dataType + '/' + this.summaryProject + '/' + this.summaryProdId + '?' + qs.stringify(body)).then(res => res.data)
          .then(res => {
            if (res.status === 'success') {
              this.luminanceOptions_G = res.data
            }
          })
        // this.luminanceOptions_G = [
        //   { text: '156', value: '156' },
        //   { text: '256', value: '256' },
        //   { text: '340', value: '340' },
        //   { text: '452', value: '452' },
        //   { text: '520', value: '520' }
        // ]
      } else if (dataType === 'colorVolume') {
        const body = {
          startTime: this.summaryRangeStartDate,
          endTime: this.summaryRangeEndDate
        }
        this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/luminance/` + dataType + '/' + this.summaryProject + '/' + this.summaryProdId + '?' + qs.stringify(body)).then(res => res.data)
          .then(res => {
            if (res.status === 'success') {
              this.luminanceOptions_C = res.data
            }
          })
        // this.luminanceOptions_C = [
        //   { text: '50 Nits', value: '50' },
        //   { text: '75 Nits', value: '75' },
        //   { text: '100 Nits', value: '100' },
        //   { text: '50% Tier', value: '50%' },
        //   { text: '100% Tier', value: '100%' }
        // ]
      } else {
        this.gamutOptions_Cov = [
          { text: 'sRGB(Result)', value: 'Result_sRGB' },
          { text: 'DisplayP3(Result)', value: 'Result_P3' },
          { text: 'sRGB', value: 'sRGB_sRGB' },
          { text: 'P3', value: 'P3_P3' }
        ]
      }

      // 当 Data Type 改变时，重置 Luminance 和 Model 的选择
      this.selectedLuminance_G = ''
      this.selectedMode_G = ''
      this.selectedLuminance_C = ''
      this.selectedColor_C = ''
      this.selectedMode_C = ''
      this.selectedgamut_Cov = ''
      this.selectedMode_Cov = ''
      this.dltpstart = ''
      this.dltpend = ''
      this.dtpstart = ''
      this.dtpend = ''
      this.lumistart = ''
      this.lumiend = ''
      this.modeOptions_G = []
      this.ColorOptions_C = []
      this.ModeOptions_C = []
      this.modeOptions_Cov = []
    },
    updateModelGOptions (luminance) {
      // 根据选中的 Luminance 模拟更新 Model 的选项
      this.modeOptions_G = [
        { text: 'Original', value: 'Original' },
        { text: 'Calibration', value: 'Calibration' },
        { text: 'Result', value: 'Result' }
      ]
    },
    updateModelCOptions (luminance) {
      const body = {
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate
      }
      this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/color/` + this.summaryProject + '/' + this.summaryProdId + '?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            const count = res.data // 假設 res.data 是 5
            this.ColorOptions_C = Array.from({ length: count + 1 }, (_, i) => ({
              text: `Color ${i}`,
              value: `${i}`
            }))
          }
        })
      // if (luminance === '50') {
      //   this.ColorOptions_C = [
      //     { text: 'Color 1', value: '1' },
      //     { text: 'Color 2', value: '2' },
      //     { text: 'Color 3', value: '3' }
      //   ]
      // } else {
      //   this.ColorOptions_C = [
      //     { text: 'Color 1', value: '1' },
      //     { text: 'Color 2', value: '2' },
      //     { text: 'Color 3', value: '3' },
      //     { text: 'Color 4', value: '4' },
      //     { text: 'Color 5', value: '5' }
      //   ]
      // }
      // 根据选中的 Luminance 模拟更新 Model 的选项
    },
    updateColorOptions (colors) {
      // 根据选中的 Luminance 模拟更新 Model 的选项
      this.ModeOptions_C = [
        { text: 'Original', value: 'Native_Color_Volume' },
        { text: 'Calibration', value: 'Color_Volume' }
      ]
    },

    updategamutOptions (colors) {
      // 根据选中的 Luminance 模拟更新 Model 的选项
      this.modeOptions_Cov = [
        { text: 'Original', value: 'Native_Coverage' },
        { text: 'Calibration', value: 'Coverage' }
      ]
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */
 .blue-dot{
  width: 5px; height: 5px; background-color: lightgreen; border-radius: 50%; position: absolute; bottom: 5px; left: 50%; transform: translateX(-50%);
 }
</style>
